// Configuración de idiomas con códigos BCP-47 y voces TTS
const LANGUAGES = {
  'es-ES': {
    code: 'es-ES',
    name: 'Español',
    nativeName: 'Español',
    voice: { lang: 'es-ES', pitch: 1.4, rate: 0.9 },
    strings: {
      title: 'DETECTIMÁTICAS DE 1º',
      welcome: '¡Hola! ¿Dispuesto a poner en práctica tus conocimientos?',
      selectLanguage: 'IDIOMA',
      start: 'COMENZAR',
      home: 'INICIO',
      exit: 'SALIR',
      contexts: 'Escoge tu aventura matemática',
      exitConfirm: '¿Estás seguro de que quieres salir?',

      // Cuestionario de configuración
      configTitle: 'Configura tu Sesión',
      back: 'Atrás',
      previous: 'ANTERIOR',
      continue: 'CONTINUAR',

      // Tipo de problema
      problemTypeTitle: 'Investigaré problemas de:',
      problemTypeAny: 'MISIÓN SORPRESA',
      problemTypeAnyDesc: 'Aventura matemática con historia continua',
      problemTypeSum: 'Suma',
      problemTypeSumDesc: 'Problemas de adición',
      problemTypeSubtraction: 'Resta',
      problemTypeSubtractionDesc: 'Problemas de sustracción',

      // Nivel
      levelTitle: '¿Qué clase de investigador eres?',
      levelBeginner: 'Aprendiz',
      levelBeginnerDesc: 'Números del 1 al 10',
      levelAdvanced: 'Avanzado',
      levelAdvancedDesc: 'Números del 10 al 25',
      levelExpert: 'Experto',
      levelExpertDesc: 'Números del 20 al 99',

      // Contexto
      contextTitle: '¿Dónde transcurre la aventura?',
      contextFilterAll: 'Todos',
      contextFilterSpecial: 'Momentos Especiales',
      contextFilterShop: 'Compras',
      contextFilterNature: 'Naturaleza',
      contextFilterDaily: 'Cotidiano',
      contextFilterPlaces: 'Lugares',

      // Modales y Herramientas
      tableSelectTitle: 'Selecciona el número',
      close: 'Cerrar',
      abnTitle: 'Resuelve con la tabla numérica',
      abnCalculating: 'Calculando:',
      abnSteps: 'Pasos:',
      abnPrev: 'Anterior',
      abnNext: 'Siguiente',
      abnUse: 'Usar resultado',

      // Pantalla Tabla Numérica
      tableScreenBack: 'Volver',
      showHelp: 'MOSTRAR AYUDA',
      hideHelp: 'OCULTAR AYUDA',
      stepBack: 'ATRÁS',
      stepNext: 'SIGUIENTE',
      lastClicked: 'Último número seleccionado',

      // Mensajes de navegación del wizard
      stepNavStep1: 'Al completar cada paso, se pasará al siguiente, pero, si lo deseas, puedes avanzar a un paso posterior',
      stepNavMiddle: 'Puedes avanzar o retroceder al paso que desees',
      stepNavLast: 'Puedes retroceder al paso que desees',

      // Wizard Step Labels
      wizardStep1Label: 'Comprensión',
      wizardStep2Label: 'Subrayado',
      wizardStep3Label: 'Representación',
      wizardStep4Label: 'Razonamiento',
      wizardStep5Label: 'Cálculo',
      wizardStep6Label: 'Respuesta',
      wizardStep1Title: '📖 Paso 1: Comprensión',

      wizardStep1Question: '¿Has comprendido el problema?',
      wizardStep1Yes: '✓ Sí, lo entiendo',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un poco de ayuda&quot; )">🔊</span> Un poco de ayuda',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un poco de ayuda&quot; )">🔊</span> 💡 Un poco de ayuda:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Preguntas&quot; )">🔊</span> ❓ 1. PREGUNTAS',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Esquema&quot; )">🔊</span> 💡 2. ESQUEMA',
      wizardStep2Title: '✏️ Paso 2: Subrayado',
      wizardStep2Instruction: 'Identifica y marca los elementos del problema',
      highlightQuestion: 'Pregunta',
      highlightUseful: 'Datos Útiles',
      highlightClear: '🗑️ Borrar',
      validateHighlight: 'Validar Subrayado',
      wizardStep3Title: '📊 Paso 3: Representación',
      wizardStep3Instruction: 'Representa las cantidades con barras',
      barLabel: 'Barra {n}: Ajusta para mostrar {value} {element}',
      barInstruction: 'DATO {n}: {value} {element}. Desplaza el círculo rojo hasta que alcance el valor {value}.',
      barInstructionSingular: 'DATO {n}: 1 {elementSingular}. Desplaza el círculo rojo hasta que alcance el valor 1.',
      validateRepresentation: 'Validar Representación',
      wizardStep4Title: '🤔 Paso 4: Razonamiento',
      wizardStep4Intro: 'Ahora, fíjate en la mayor de esas cantidades ({data}) y completa:',
      quantitiesReminder: '📊 Recordatorio de las cantidades:',
      largestDataLabel: 'El mayor de los datos relacionados con la pregunta es:',
      chooseLargest: '-- Elige el número mayor --',
      rememberQuestion: 'Recuerda la pregunta:',
      thinkAndAnswer: 'Y ahora piensa y contesta, ¿Al final, el número de',
      willBeGreaterOrLess: 'será mayor o menor que',
      thanWord: 'que',
      chooseOption: '-- Elige --',
      optionGreater: 'MAYOR',
      optionLess: 'MENOR',
      validate: 'Validar',
      operationQuestion: 'Por último, debes decidir qué operación habrá que realizar para contestar a esa pregunta: ¿Suma o Resta?',
      optionSum: 'SUMA',
      optionSubtraction: 'RESTA',
      validateContinue: 'Validar y Continuar',
      helpButton: 'AYUDA',
      helpText: 'Recuerda que si el resultado que esperamos es mayor que {value}, deberás realizar una SUMA, pero que si el resultado que esperamos es menor que {value}, deberás realizar una RESTA.',
      wizardStep5Title: '🧮 Paso 5: Cálculo',
      wizardStep5Instruction: 'ESCOGE UNO DE LOS 3 MÉTODOS PARA CALCULAR LA SOLUCIÓN',
      method1Title: 'REALIZA ESTA OPERACIÓN MATEMÁTICA COMPLETANDO LA TABLA',
      method2Title: 'RESUELVE CON LA TABLA NUMÉRICA',
      method3Title: 'CALCULA MENTALMENTE Y SELECCIONA',
      checkButton: 'COMPROBAR',
      selectNumberBtn: 'Seleccionar número',
      solveWithTable: 'Resolver utilizando la tabla numérica',
      successCorrect: '¡CORRECTO!',
      successFound: 'Has encontrado la respuesta',
      wizardStep6Title: '✍️ Paso 6: Respuesta Final',
      wizardStep6Instruction: 'Escribe la respuesta completa',
      rememberOperation: 'Recuerda que has',
      addedVerb: 'sumado',
      subtractedVerb: 'restado',
      thereforeAnswer: ', por tanto, la respuesta es:',
      submitAnswer: 'Enviar Respuesta',
      summaryLabel: '📝 Resumen',
      summaryOperation: 'Operación:',
      summaryResult: 'Resultado:',
      goToCalcBtn: '🔢 Cálculo',

      // Feedback Messages
      feedbackPerfect: '¡Perfecto!',
      feedbackVeryGood: '¡Muy bien!',
      feedbackGreat: '¡Genial!',
      feedbackCorrect: '¡Correcto!',
      feedbackFantastic: '¡Fantástico!',
      feedbackTableCorrect: '¡La tabla está correcta!',
      feedbackReasoningCorrect: '¡Bien pensado! Ahora decide la operación.',
      feedbackWhySum: '¿Seguro? Si esperamos un resultado menor, ¿debemos sumar?',
      feedbackWhySub: '¿Seguro? Si esperamos un resultado mayor, ¿debemos restar?',
      feedbackOperationCorrect: '¡Operación correcta! Ahora calcula la respuesta final.',
      feedbackTryHighlight: 'Intenta marcar la pregunta y al menos un dato útil.',
      feedbackHighlightQuestionMissing: 'Recuerda que la pregunta está entre las interrogaciones (¿...?).',
      feedbackHighlightDataWrong: 'Revisa los datos útiles. Recuerda que son los números o cantidades relacionados con la pregunta que se hace, en este caso, serán las cantidades de {element}.',
      feedbackHighlightBothWrong: 'Recuerda: la pregunta está entre las interrogaciones (¿...?) y los datos útiles son los números relacionados con la pregunta.',
      feedbackSelectNumber: 'Por favor, selecciona uno de los números.',
      feedbackLookBars: 'Fíjate bien en las barras para saber cuál es el número mayor.',
      feedbackSelectMagnitude: 'Por favor, selecciona si será MAYOR o MENOR.',
      feedbackSelectOption: 'Por favor, elige una opción.',
      feedbackThinkAgain: 'Piénsalo un poco mejor.',
      feedbackSelectOperation: 'Por favor, selecciona la operación (SUMA o RESTA).',
      feedbackCompleteCalc: 'Completa el cálculo usando la tabla, el selector numérico o la ayuda ABN',
      feedbackCheckCalc: 'Revisa tu cálculo.',
      feedbackSelectResult: 'Por favor, selecciona un número para el resultado.',
      feedbackValuesAre: 'Los valores del problema son {values}. Ajusta las barras correctamente.',
      feedbackNumberCorrectButName: 'El número {number} es correcto, pero revisa el nombre del objeto. Debe ser "{name}".',
      feedbackNameCorrectButNumber: 'El nombre "{name}" es correcto, pero el número debería ser {number}.',
      feedbackCorrectAnswer: 'La respuesta correcta era {answer} {element}. ¡Sigue intentando!',
      feedbackMentalCalcError: 'Recuerda que puedes usar cualquiera de los métodos anteriores',

      // Hints
      hintLargestNumber: 'Pista: ¿Cuál de los datos tiene un número mayor? Compara: {values}.',
      hintSumResult: 'Pista: Si sumamos dos cantidades, ¿el resultado será mayor o menor que cada una de ellas?',
      hintSubResult: 'Pista: Si restamos una cantidad a otra, ¿el resultado será mayor o menor que la cantidad original?',
      hintExpectGreater: 'Pista: Si esperamos un resultado mayor, ¿qué operación usamos para juntar cantidades?',
      hintExpectLess: 'Pista: Si esperamos un resultado menor, ¿qué operación usamos para quitar una cantidad?',

      // Numeric Table Screen
      lastSelected: 'Último número seleccionado:',
      sendAnswer: 'ENVIAR RESPUESTA',
      resetTable: '🔄 COMENZAR DE NUEVO',
      yourAnswer: 'Tu respuesta:',
      send: 'ENVIAR',
      wrongAnswer: 'Respuesta incorrecta. Piensa más o usa otro método.',
      wrongAnswerLong: 'El número que has seleccionado no es la respuesta correcta.',
      useHelpHint: '💡 Usa el botón "MOSTRAR AYUDA" para que te guiemos paso a paso hasta la solución.',
      step: 'PASO',
      findNumber: 'Busca y haz clic en el número',
      understood: 'ENTENDIDO',

      // Navigation
      configuration: 'Configuración',
      problemCounter: 'Problema {current} de {total}',
      sessionComplete: '¡Sesión Completada!',
      yourScore: 'Tu Puntuación',
      excellentWork: '¡Excelente trabajo, Detective Matemático!',
      missionComplete: '¡Misión cumplida! Has ganado puntos de experiencia y medallas por tu gran labor detectivesca al resolver este caso. Pero espera... Acabo de encontrar unas huellas extrañas cerca de la puerta. ¡Parece que tenemos un nuevo misterio que resolver pronto!',
      newSession: 'Nueva Sesión',
      backToHome: 'Volver al Inicio',
      loading: 'Cargando aventura...',
      readProblem: 'Lee el Problema',
      problemTextAudio: 'TEXTO/AUDIO del problema',
      startAdventure: 'COMENZAR LA AVENTURA',
      previousStep: 'Paso Anterior',
      nextProblem: 'Siguiente Problema',
      finishSession: 'Finalizar Sesión',
      units: 'unidades',
      tableUnits: 'U',
      tableTens: 'D',
      backToStart: 'Volver al Inicio',
      exitApp: 'SALIR',
      farewellMessage: '¡Hasta pronto, Detective Matemático! Vuelve cuando quieras a demostrar tus dotes de investigador matemático. ¡Te esperamos!',
      printProblem: 'IMPRIMIR PROBLEMA'
    }
  },
  'ca-ES': {
    code: 'ca-ES',
    name: 'Catalán',
    nativeName: 'Català',
    voice: { lang: 'ca-ES', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'DETECTIUS MATEMÀTICS DE 1r',
      welcome: 'Hola! Estàs disposat a posar en pràctica els teus coneixements?',
      selectLanguage: 'IDIOMA',
      start: 'COMENÇAR',
      home: 'INICI',
      exit: 'SORTIR',
      contexts: 'Tria la teva aventura matemàtica',
      exitConfirm: 'Estàs segur que vols sortir?',

      configTitle: 'Configura la teva Sessió',
      back: 'Enrere',
      previous: 'ANTERIOR',
      continue: 'CONTINUAR',

      problemTypeTitle: 'Què vols practicar?',
      problemTypeAny: 'Suma o Resta',
      problemTypeAnyDesc: 'Barreja de problemes de suma o resta',
      problemTypeSum: 'Suma',
      problemTypeSumDesc: 'Problemes d\'addició',
      problemTypeSubtraction: 'Resta',
      problemTypeSubtractionDesc: 'Problemes de sostracció',

      levelTitle: 'Quina classe d\'investigador ets?',
      levelBeginner: 'Aprenent',
      levelBeginnerDesc: 'Números de l\'1 al 20',
      levelAdvanced: 'Avançat',
      levelAdvancedDesc: 'Números del 21 al 50',
      levelExpert: 'Expert',
      levelExpertDesc: 'Números del 51 al 100',

      contextTitle: 'On transcorre l\'aventura?',
      contextFilterAll: 'Tots',
      contextFilterSpecial: 'Moments Especials',
      contextFilterShop: 'Compres',
      contextFilterNature: 'Naturalesa',
      contextFilterDaily: 'Quotidià',
      contextFilterPlaces: 'Llocs',

      tableSelectTitle: 'Selecciona el número',
      close: 'Tancar',
      abnTitle: 'Ajuda Taula Numèrica',
      abnCalculating: 'Calculant:',
      abnSteps: 'Passos:',
      abnPrev: 'Anterior',
      abnNext: 'Següent',
      abnUse: 'Utilitzar resultat',

      stepNavStep1: 'En completar cada pas, es passarà al següent, però, si ho desitges, pots avançar a un pas posterior',
      stepNavMiddle: 'Pots avançar o retrocedir al pas que vulguis',
      stepNavLast: 'Pots retrocedir al pas que vulguis',

      wizardStep1Label: 'Comprensió',
      wizardStep2Label: 'Subratllat',
      wizardStep3Label: 'Representació',
      wizardStep4Label: 'Raonament',
      wizardStep5Label: 'Càlcul',
      wizardStep6Label: 'Resposta',
      wizardStep1Title: '📖 Pas 1: Comprensió',

      wizardStep1Question: 'Has comprès el problema?',
      wizardStep1Yes: '✓ Sí, l\'entenc',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Una mica d\'ajuda&quot; )">🔊</span> Una mica d\'ajuda',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Una mica d\'ajuda&quot; )">🔊</span> 💡 Una mica d\'ajuda:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Preguntes&quot; )">🔊</span> ❓ 1. PREGUNTES',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Esquema&quot; )">🔊</span> 💡 2. ESQUEMA',
      wizardStep2Title: '✏️ Pas 2: Subratllat',
      wizardStep2Instruction: 'Identifica i marca els elements del problema',
      highlightQuestion: 'Pregunta',
      highlightUseful: 'Dades Útils',
      highlightClear: '🗑️ Esborrar',
      validateHighlight: 'Validar Subratllat',
      wizardStep3Title: '📊 Pas 3: Representació',
      wizardStep3Instruction: 'Representa les quantitats amb barres',
      barLabel: 'Barra {n}: Ajusta per mostrar {value} {element}',
      barInstruction: 'Desplaça el cercle vermell fins arribar al valor {value}, ja que són {value} {element}',
      validateRepresentation: 'Validar Representació',
      wizardStep4Title: '🤔 Pas 4: Raonament',
      wizardStep4Intro: 'Ara, fixa\'t en la major d\'aquestes quantitats ({data}) i completa:',
      quantitiesReminder: '📊 Recordatori de les quantitats:',
      largestDataLabel: 'El major de les dades relacionades amb la pregunta és:',
      chooseLargest: '-- Tria el número major --',
      rememberQuestion: 'Recorda la pregunta:',
      thinkAndAnswer: 'I ara pensa i contesta, al final, el número de',
      willBeGreaterOrLess: 'serà major o menor que',
      thanWord: 'que',
      chooseOption: '-- Tria --',
      optionGreater: 'MAJOR',
      optionLess: 'MENOR',
      validate: 'Validar',
      operationQuestion: 'Per últim, has de decidir quina operació caldrà fer per contestar aquesta pregunta: Suma o Resta?',
      optionSum: 'SUMA',
      optionSubtraction: 'RESTA',
      validateContinue: 'Validar i Continuar',
      helpButton: 'AJUDA',
      helpText: 'Recorda que si el resultat que esperem és major que {value}, hauràs de fer una SUMA, però que si el resultat que esperem és menor que {value}, hauràs de fer una RESTA.',
      wizardStep5Title: '🧮 Pas 5: Càlcul',
      wizardStep5Instruction: 'TRIA UN DELS 3 MÈTODES PER CALCULAR LA SOLUCIÓ',
      method1Title: 'REALITZA AQUESTA OPERACIÓ MATEMÀTICA COMPLETANT LA TAULA',
      method2Title: 'RESOL AMB LA TAULA NUMÈRICA',
      method3Title: 'CALCULA MENTALMENT I SELECCIONA',
      checkButton: 'COMPROVAR',
      selectNumberBtn: 'Seleccionar número',
      solveWithTable: 'Resoldre utilitzant la taula numèrica',
      successCorrect: 'CORRECTE!',
      successFound: 'Has trobat la resposta',
      wizardStep6Title: '✍️ Pas 6: Resposta Final',
      wizardStep6Instruction: 'Escriu la resposta completa',
      rememberOperation: 'Recorda que has',
      addedVerb: 'sumat',
      subtractedVerb: 'restat',
      thereforeAnswer: ', per tant, la resposta és:',
      submitAnswer: 'Enviar Resposta',
      summaryLabel: '📝 Resum',
      summaryOperation: 'Operació:',
      summaryResult: 'Resultat:',
      goToCalcBtn: '🔢 Càlcul',
      feedbackPerfect: 'Perfecte!',
      feedbackVeryGood: 'Molt bé!',
      feedbackGreat: 'Genial!',
      feedbackCorrect: 'Correcte!',
      feedbackFantastic: 'Fantàstic!',
      feedbackTableCorrect: 'La taula és correcta!',
      feedbackOperationCorrect: 'Operació correcta! Ara escriu la resposta final.',
      feedbackTryHighlight: 'Intenta marcar la pregunta i almenys una dada útil.',
      feedbackHighlightQuestionMissing: 'Recorda que la pregunta està entre les interrogacions (¿...?).',
      feedbackHighlightDataWrong: 'Revisa les dades útils. Recorda que són els números o quantitats relacionats amb la pregunta que es fa, en aquest cas, seran les quantitats de {element}.',
      feedbackHighlightBothWrong: 'Recorda: la pregunta està entre les interrogacions (¿...?) i les dades útils són els números relacionats amb la pregunta.',
      feedbackSelectNumber: 'Si us plau, selecciona un dels números.',
      feedbackSelectMagnitude: 'Si us plau, selecciona si serà MAJOR o MENOR.',
      feedbackSelectOperation: 'Si us plau, selecciona l\'operació (SUMA o RESTA).',
      feedbackCompleteCalc: 'Completa el càlcul usant la taula, el selector numèric o l\'ajuda',
      feedbackCheckCalc: 'Revisa el teu càlcul.',
      feedbackSelectResult: 'Si us plau, selecciona un número per al resultat.',
      feedbackValuesAre: 'Els valors del problema són {values}. Ajusta les barres correctament.',
      feedbackNumberCorrectButName: 'El número {number} és correcte, però revisa el nom de l\'objecte. Ha de ser "{name}".',
      feedbackNameCorrectButNumber: 'El nom "{name}" és correcte, però el número hauria de ser {number}.',
      feedbackCorrectAnswer: 'La resposta correcta era {answer} {element}. Continua intentant-ho!',
      hintLargestNumber: 'Pista: Quin número és el major? Compara: {values}.',
      hintSumResult: 'Pista: Si sumem dues quantitats, el resultat serà major o menor que cadascuna d\'elles?',
      hintSubResult: 'Pista: Si restem una quantitat d\'una altra, el resultat serà major o menor que l\'original?',
      hintExpectGreater: 'Pista: Si esperem un resultat major, quina operació fem servir per juntar quantitats?',
      hintExpectLess: 'Pista: Si esperem un resultat menor, quina operació fem servir per treure una quantitat?',
      lastSelected: 'Últim número seleccionat:',
      sendAnswer: 'ENVIAR RESPOSTA',
      resetTable: '🔄 COMENÇAR DE NOU',
      yourAnswer: 'La teva resposta:',
      send: 'ENVIAR',
      wrongAnswer: 'Resposta incorrecta. Pensa més o usa un altre mètode.',
      wrongAnswerLong: 'El número que has seleccionat no és la resposta correcta.',
      useHelpHint: '💡 Usa el botó "MOSTRAR AJUDA" perquè et guiem pas a pas fins a la solució.',
      step: 'PAS',
      findNumber: 'Busca i fes clic al número',
      understood: 'ENTÈS',
      tableScreenBack: 'Tornar',
      showHelp: 'MOSTRAR AJUDA',
      hideHelp: 'AMAGAR AJUDA',
      stepBack: 'ENRERE',
      stepNext: 'SEGÜENT',
      lastClicked: 'Últim número seleccionat',
      configuration: 'Configuració',
      problemCounter: 'Problema {current} de {total}',
      sessionComplete: 'Sessió Completada!',
      yourScore: 'La teva Puntuació',
      excellentWork: 'Excel·lent treball, Detectiu Matemàtic!',
      missionComplete: 'Missió complida! Has guanyat punts d\'experiència i medalles per la teva gran tasca detectivesca en resoldre aquest cas.',
      newSession: 'Nova Sessió',
      backToHome: 'Tornar a l\'Inici',
      loading: 'Carregant aventura...',
      readProblem: 'Llegeix el Problema',
      problemTextAudio: 'TEXT/ÀUDIO del problema',
      startAdventure: 'COMENÇAR L\'AVENTURA',
      previousStep: 'Pas Anterior',
      nextProblem: 'Següent Problema',
      finishSession: 'Finalitzar Sessió',
      units: 'unitats',
      tableUnits: 'U',
      tableTens: 'D'
    }
  },
  'eu-ES': {
    code: 'eu-ES',
    name: 'Euskera',
    nativeName: 'Euskara',
    voice: { lang: 'eu-ES', pitch: 1.2, rate: 0.8 },
    strings: {
      title: '1. MAILAKO DETEKTIBE MATEMATIKOAK',
      welcome: 'Kaixo! Zure ezagutza praktikan jartzeko prest?',
      selectLanguage: 'HIZKUNTZA',
      start: 'HASI',
      home: 'HASIERA',
      exit: 'IRTEN',
      contexts: 'Aukeratu zure abentura matematikoa',
      exitConfirm: 'Ziur zaude irten nahi duzula?',

      configTitle: 'Konfiguratu zure Saioa',
      back: 'Atzera',
      previous: 'AURREKOA',
      continue: 'JARRAITU',

      problemTypeTitle: 'Zer praktikatu nahi duzu?',
      problemTypeAny: 'Batuketa edo Kenketa',
      problemTypeAnyDesc: 'Batuketa edo kenketa arauen nahasketa',
      problemTypeSum: 'Batuketa',
      problemTypeSumDesc: 'Gehiketaren arazoak',
      problemTypeSubtraction: 'Kenketa',
      problemTypeSubtractionDesc: 'Kenketaren arazoak',

      levelTitle: 'Zein ikertzaile mota zara?',
      levelBeginner: 'Hasiberria',
      levelBeginnerDesc: '1etik 10era zenbakiak',
      levelAdvanced: 'Aurreratua',
      levelAdvancedDesc: '1etik 20ra zenbakiak',
      levelExpert: 'Aditua',
      levelExpertDesc: '1etik 50era zenbakiak',

      contextTitle: 'Non gertatzen da abentura?',
      contextFilterAll: 'Guztiak',
      contextFilterSpecial: 'Une Bereziak',
      contextFilterShop: 'Erosketak',
      contextFilterNature: 'Natura',
      contextFilterDaily: 'Egunerokoa',
      contextFilterPlaces: 'Lekuak',

      tableSelectTitle: 'Zenbakia hautatu',
      close: 'Itxi',
      abnTitle: 'Zenbakizko Taula Laguntza',
      abnCalculating: 'Kalkulatzen:',
      abnSteps: 'Urratsak:',
      abnPrev: 'Aurrekoa',
      abnNext: 'Hurrengoa',
      abnUse: 'Emaitza erabili',

      stepNavStep1: 'Urrats bakoitza osatuz gero, hurrengora pasako da, baina, nahi baduzu, aurrerago joan zaitezke',
      stepNavMiddle: 'Aurrera edo atzera joan zaitezke nahi duzun urratsera',
      stepNavLast: 'Atzera joan zaitezke nahi duzun urratsera',

      wizardStep1Label: 'Ulermena',
      wizardStep2Label: 'Nabarmentzea',
      wizardStep3Label: 'Adierazpena',
      wizardStep4Label: 'Arrazoiketa',
      wizardStep5Label: 'Kalkulua',
      wizardStep6Label: 'Erantzuna',
      wizardStep1Title: '📖 1. Urratsa: Ulermena',

      wizardStep1Question: 'Problema ulertu duzu?',
      wizardStep1Yes: '✓ Bai, ulertzen dut',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Laguntza pixka bat&quot; )">🔊</span> Laguntza pixka bat',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Laguntza pixka bat&quot; )">🔊</span> 💡 Laguntza pixka bat:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Galderak&quot; )">🔊</span> ❓ 1. GALDERAK',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Eskema&quot; )">🔊</span> 💡 2. ESKEMA',
      wizardStep2Title: '✏️ 2. Urratsa: Nabarmentzea',
      wizardStep2Instruction: 'Identifikatu eta markatu problemaren elementuak',
      highlightQuestion: 'Galdera',
      highlightUseful: 'Datu Erabilgarriak',
      highlightClear: '🗑️ Ezabatu',
      validateHighlight: 'Nabarmentzea Balioztatu',
      wizardStep3Title: '📊 3. Urratsa: Adierazpena',
      wizardStep3Instruction: 'Adierazi kantitateak barrekin',
      barLabel: '{n}. Barra: Doitu {value} {element} erakusteko',
      barInstruction: 'Lekualdatu zirkulu gorria {value} baliora iristeko, {value} {element} baitira',
      validateRepresentation: 'Adierazpena Balioztatu',
      wizardStep4Title: '🤔 4. Urratsa: Arrazoiketa',
      wizardStep4Intro: 'Orain, begiratu kantitate handienari ({data}) eta osatu:',
      quantitiesReminder: '📊 Kantitateen gogorarazpena:',
      largestDataLabel: 'Galderarekin lotutako zenbakirik handiena da:',
      chooseLargest: '-- Aukeratu zenbaki handiena --',
      rememberQuestion: 'Gogoratu galdera:',
      thinkAndAnswer: 'Orain pentsatu eta erantzun, azkenean zenbat',
      willBeGreaterOrLess: 'handiagoa edo txikiagoa izango da',
      thanWord: 'baino',
      chooseOption: '-- Aukeratu --',
      optionGreater: 'HANDIAGOA',
      optionLess: 'TXIKIAGOA',
      validate: 'Balioztatu',
      operationQuestion: 'Azkenik, erabaki zein eragiketa egin behar duzun galderari erantzuteko: Batuketa edo Kenketa?',
      optionSum: 'BATUKETA',
      optionSubtraction: 'KENKETA',
      validateContinue: 'Balioztatu eta Jarraitu',
      helpButton: 'LAGUNTZA',
      helpText: 'Gogoratu espero dugun emaitza {value} baino handiagoa bada, BATUKETA egin behar duzula, baina espero dugun emaitza {value} baino txikiagoa bada, KENKETA egin behar duzula.',
      wizardStep5Title: '🧮 5. Urratsa: Kalkulua',
      wizardStep5Instruction: 'AUKERATU 3 METODOETATIK BAT EMAITZA KALKULATZEKO',
      method1Title: 'OSATU ERAGIKETA MATEMATIKO HAU TAULA BETEZ',
      method2Title: 'EBATZI ZENBAKI-TAULAREKIN',
      method3Title: 'KALKULATU MENTALKI ETA AUKERATU',
      checkButton: 'EGIAZTATU',
      selectNumberBtn: 'Zenbakia aukeratu',
      solveWithTable: 'Zenbaki-taularekin ebatzi',
      successCorrect: 'ZUZENA!',
      successFound: 'Erantzuna aurkitu duzu',
      wizardStep6Title: '✍️ 6. Urratsa: Azken Erantzuna',
      wizardStep6Instruction: 'Idatzi erantzun osoa',
      rememberOperation: 'Gogoratu',
      addedVerb: 'batu',
      subtractedVerb: 'kendu',
      thereforeAnswer: ' duzula, beraz, erantzuna da:',
      submitAnswer: 'Erantzuna Bidali',
      summaryLabel: '📝 Laburpena',
      summaryOperation: 'Eragiketa:',
      summaryResult: 'Emaitza:',
      goToCalcBtn: '🔢 Kalkulua',
      feedbackPerfect: 'Bikain!',
      feedbackVeryGood: 'Oso ondo!',
      feedbackGreat: 'Primeran!',
      feedbackCorrect: 'Zuzena!',
      feedbackFantastic: 'Zoragarria!',
      feedbackTableCorrect: 'Taula zuzena da!',
      feedbackOperationCorrect: 'Eragiketa zuzena! Orain idatzi azken erantzuna.',
      feedbackTryHighlight: 'Saiatu galdera eta gutxienez datu erabilgarri bat markatzen.',
      feedbackHighlightQuestionMissing: 'Gogoratu galdera galdera-ikurren artean (¿...?) dagoela.',
      feedbackHighlightDataWrong: 'Berrikusi datu erabilgarriak. Gogoratu galderarekin lotutako zenbakiak edo kantitateak direla, kasu honetan, {element} kantitateak izango dira.',
      feedbackHighlightBothWrong: 'Gogoratu: galdera galdera-ikurren artean (¿...?) dago eta datu erabilgarriak galderarekin lotutako zenbakiak dira.',
      feedbackSelectNumber: 'Mesedez, aukeratu zenbakietako bat.',
      feedbackSelectMagnitude: 'Mesedez, aukeratu HANDIAGOA edo TXIKIAGOA izango den.',
      feedbackSelectOperation: 'Mesedez, aukeratu eragiketa (BATUKETA edo KENKETA).',
      feedbackCompleteCalc: 'Osatu kalkulua taula, zenbaki-hautatzailea edo laguntza erabiliz',
      feedbackCheckCalc: 'Egiaztatu zure kalkulua.',
      feedbackSelectResult: 'Mesedez, aukeratu zenbaki bat emaitzetarako.',
      feedbackValuesAre: 'Problemaren balioak {values} dira. Doitu barrak zuzen.',
      feedbackNumberCorrectButName: '{number} zenbakia zuzena da, baina egiaztatu objektuaren izena. "{name}" izan behar du.',
      feedbackNameCorrectButNumber: '"{name}" izena zuzena da, baina zenbakia {number} izan behar du.',
      feedbackCorrectAnswer: 'Erantzun zuzena {answer} {element} zen. Jarraitu saiatzen!',
      hintLargestNumber: 'Pista: Zein zenbaki da handiena? Konparatu: {values}.',
      hintSumResult: 'Pista: Bi kantitate batzen baditugu, emaitza handiagoa edo txikiagoa izango da bakoitza baino?',
      hintSubResult: 'Pista: Kantitate bat beste bati kentzen badiogu, emaitza handiagoa edo txikiagoa izango da jatorrizkoa baino?',
      hintExpectGreater: 'Pista: Emaitza handiagoa espero badugu, zein eragiketa erabiltzen dugu kantitateak elkartzeko?',
      hintExpectLess: 'Pista: Emaitza txikiagoa espero badugu, zein eragiketa erabiltzen dugu kantitate bat kentzeko?',
      lastSelected: 'Azken zenbaki hautatua:',
      sendAnswer: 'ERANTZUNA BIDALI',
      resetTable: '🔄 BERRIZ HASI',
      yourAnswer: 'Zure erantzuna:',
      send: 'BIDALI',
      wrongAnswer: 'Erantzun okerra. Pentsatu gehiago edo erabili beste metodo bat.',
      wrongAnswerLong: 'Aukeratu duzun zenbakia ez da erantzun zuzena.',
      useHelpHint: '💡 Erabili "LAGUNTZA ERAKUTSI" botoia soluziora urrats bakoitzean gidatzeko.',
      step: 'URRATSA',
      findNumber: 'Bilatu eta egin klik zenbakian',
      understood: 'ULERTUTA',
      tableScreenBack: 'Atzera',
      showHelp: 'LAGUNTZA ERAKUTSI',
      hideHelp: 'LAGUNTZA EZKUTATU',
      stepBack: 'ATZERA',
      stepNext: 'HURRENGOA',
      lastClicked: 'Azken zenbaki hautatua',
      configuration: 'Konfigurazioa',
      problemCounter: '{current}. problema {total}-(e)tik',
      sessionComplete: 'Saioa Osatua!',
      yourScore: 'Zure Puntuazioa',
      excellentWork: 'Lan bikaina, Detektibe Matematikoa!',
      missionComplete: 'Misioa beteta! Esperientzia puntuak eta dominak irabazi dituzu kasu hau ebaztean egindako detektibe lan bikainagatik.',
      newSession: 'Saio Berria',
      backToHome: 'Hasierara Itzuli',
      loading: 'Abentura kargatzen...',
      readProblem: 'Irakurri Problema',
      problemTextAudio: 'Problemaren TESTUA/AUDIOA',
      startAdventure: 'ABENTURA HASI',
      previousStep: 'Aurreko Urratsa',
      nextProblem: 'Hurrengo Problema',
      finishSession: 'Saioa Amaitu',
      units: 'unitate',
      tableUnits: 'B',
      tableTens: 'H'
    }
  },
  'gl-ES': {
    code: 'gl-ES',
    name: 'Gallego',
    nativeName: 'Galego',
    voice: { lang: 'gl-ES', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'DETECTIMÁTICAS DE 1º',
      welcome: 'Ola! Disposto a poñer en práctica os teus coñecementos?',
      selectLanguage: 'IDIOMA',
      start: 'COMEZAR',
      home: 'INICIO',
      exit: 'SAÍR',
      contexts: 'Escolle a túa aventura matemática',
      exitConfirm: 'Estás seguro de que queres saír?',

      configTitle: 'Configura a túa Sesión',
      back: 'Atrás',
      previous: 'ANTERIOR',
      continue: 'CONTINUAR',

      problemTypeTitle: 'Que queres practicar?',
      problemTypeAny: 'Suma ou Resta',
      problemTypeAnyDesc: 'Mestura de problemas de suma ou resta',
      problemTypeSum: 'Suma',
      problemTypeSumDesc: 'Problemas de adición',
      problemTypeSubtraction: 'Resta',
      problemTypeSubtractionDesc: 'Problemas de sustracción',

      levelTitle: 'Que clase de investigador es?',
      levelBeginner: 'Aprendiz',
      levelBeginnerDesc: 'Números do 1 ao 10',
      levelAdvanced: 'Avanzado',
      levelAdvancedDesc: 'Números do 1 ao 20',
      levelExpert: 'Experto',
      levelExpertDesc: 'Números do 1 ao 50',

      contextTitle: 'Onde transcorre a aventura?',
      contextFilterAll: 'Todos',
      contextFilterSpecial: 'Momentos Especiais',
      contextFilterShop: 'Compras',
      contextFilterNature: 'Natureza',
      contextFilterDaily: 'Cotiá',
      contextFilterPlaces: 'Lugares',

      tableSelectTitle: 'Selecciona o número',
      close: 'Pechar',
      abnTitle: 'Axuda Táboa Numérica',
      abnCalculating: 'Calculando:',
      abnSteps: 'Pasos:',
      abnPrev: 'Anterior',
      abnNext: 'Seguinte',
      abnUse: 'Usar resultado',

      stepNavStep1: 'Ao completar cada paso, pasarase ao seguinte, pero, se o desexas, podes avanzar a un paso posterior',
      stepNavMiddle: 'Podes avanzar ou retroceder ao paso que desexes',
      stepNavLast: 'Podes retroceder ao paso que desexes',

      wizardStep1Label: 'Comprensión',
      wizardStep2Label: 'Subliñado',
      wizardStep3Label: 'Representación',
      wizardStep4Label: 'Razoamento',
      wizardStep5Label: 'Cálculo',
      wizardStep6Label: 'Resposta',
      wizardStep1Title: '📖 Paso 1: Comprensión',

      wizardStep1Question: 'Comprendiches o problema?',
      wizardStep1Yes: '✓ Si, enténdoo',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un pouco de axuda&quot; )">🔊</span> Un pouco de axuda',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un pouco de axuda&quot; )">🔊</span> 💡 Un pouco de axuda:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Preguntas&quot; )">🔊</span> ❓ 1. PREGUNTAS',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Esquema&quot; )">🔊</span> 💡 2. ESQUEMA',
      wizardStep2Title: '✏️ Paso 2: Subliñado',
      wizardStep2Instruction: 'Identifica e marca os elementos do problema',
      highlightQuestion: 'Pregunta',
      highlightUseful: 'Datos Útiles',
      highlightClear: '🗑️ Borrar',
      validateHighlight: 'Validar Subliñado',
      wizardStep3Title: '📊 Paso 3: Representación',
      wizardStep3Instruction: 'Representa as cantidades con barras',
      barLabel: 'Barra {n}: Axusta para mostrar {value} {element}',
      barInstruction: 'Despraza o círculo vermello ata alcanzar o valor {value}, xa que son {value} {element}',
      validateRepresentation: 'Validar Representación',
      wizardStep4Title: '🤔 Paso 4: Razoamento',
      wizardStep4Intro: 'Agora, fíxate na maior destas cantidades ({data}) e completa:',
      quantitiesReminder: '📊 Recordatorio das cantidades:',
      largestDataLabel: 'O maior dos datos relacionados coa pregunta é:',
      chooseLargest: '-- Escolle o número maior --',
      rememberQuestion: 'Lembra a pregunta:',
      thinkAndAnswer: 'E agora pensa e contesta, ao final, o número de',
      willBeGreaterOrLess: 'será maior ou menor que',
      thanWord: 'que',
      chooseOption: '-- Escolle --',
      optionGreater: 'MAIOR',
      optionLess: 'MENOR',
      validate: 'Validar',
      operationQuestion: 'Por último, debes decidir que operación haberá que realizar para contestar a esa pregunta: Suma ou Resta?',
      optionSum: 'SUMA',
      optionSubtraction: 'RESTA',
      validateContinue: 'Validar e Continuar',
      helpButton: 'AXUDA',
      helpText: 'Lembra que se o resultado que esperamos é maior que {value}, deberás realizar unha SUMA, pero que se o resultado que esperamos é menor que {value}, deberás realizar unha RESTA.',
      wizardStep5Title: '🧮 Paso 5: Cálculo',
      wizardStep5Instruction: 'ESCOLLE UN DOS 3 MÉTODOS PARA CALCULAR A SOLUCIÓN',
      method1Title: 'REALIZA ESTA OPERACIÓN MATEMÁTICA COMPLETANDO A TÁBOA',
      method2Title: 'RESOLVE COA TÁBOA NUMÉRICA',
      method3Title: 'CALCULA MENTALMENTE E SELECCIONA',
      checkButton: 'COMPROBAR',
      selectNumberBtn: 'Seleccionar número',
      solveWithTable: 'Resolver utilizando a táboa numérica',
      successCorrect: 'CORRECTO!',
      successFound: 'Atopaches a resposta',
      wizardStep6Title: '✍️ Paso 6: Resposta Final',
      wizardStep6Instruction: 'Escribe a resposta completa',
      rememberOperation: 'Lembra que',
      addedVerb: 'sumaches',
      subtractedVerb: 'restaches',
      thereforeAnswer: ', polo tanto, a resposta é:',
      submitAnswer: 'Enviar Resposta',
      summaryLabel: '📝 Resumo',
      summaryOperation: 'Operación:',
      summaryResult: 'Resultado:',
      goToCalcBtn: '🔢 Cálculo',
      feedbackPerfect: 'Perfecto!',
      feedbackVeryGood: 'Moi ben!',
      feedbackGreat: 'Xenial!',
      feedbackCorrect: 'Correcto!',
      feedbackFantastic: 'Fantástico!',
      feedbackTableCorrect: 'A táboa está correcta!',
      feedbackOperationCorrect: 'Operación correcta! Agora calcula a resposta final.',
      feedbackTryHighlight: 'Intenta marcar a pregunta e polo menos un dato útil.',
      feedbackHighlightQuestionMissing: 'Lembra que a pregunta está entre as interrogacións (¿...?).',
      feedbackHighlightDataWrong: 'Revisa os datos útiles. Lembra que son os números ou cantidades relacionados coa pregunta que se fai, neste caso, serán as cantidades de {element}.',
      feedbackHighlightBothWrong: 'Lembra: a pregunta está entre as interrogacións (¿...?) e os datos útiles son os números relacionados coa pregunta.',
      feedbackSelectNumber: 'Por favor, selecciona un dos números.',
      feedbackSelectMagnitude: 'Por favor, selecciona se será MAIOR ou MENOR.',
      feedbackSelectOperation: 'Por favor, selecciona a operación (SUMA ou RESTA).',
      feedbackCompleteCalc: 'Completa o cálculo usando a táboa, o selector numérico ou a axuda',
      feedbackCheckCalc: 'Revisa o teu cálculo.',
      feedbackSelectResult: 'Por favor, selecciona un número para o resultado.',
      feedbackValuesAre: 'Os valores do problema son {values}. Axusta as barras correctamente.',
      feedbackNumberCorrectButName: 'O número {number} é correcto, pero revisa o nome do obxecto. Debe ser "{name}".',
      feedbackNameCorrectButNumber: 'O nome "{name}" é correcto, pero o número debería ser {number}.',
      feedbackCorrectAnswer: 'A resposta correcta era {answer} {element}. Segue intentándoo!',
      hintLargestNumber: 'Pista: Cal é o número maior? Compara: {values}.',
      hintSumResult: 'Pista: Se sumamos dúas cantidades, o resultado será maior ou menor que cada unha delas?',
      hintSubResult: 'Pista: Se restamos unha cantidade a outra, o resultado será maior ou menor que a orixinal?',
      hintExpectGreater: 'Pista: Se esperamos un resultado maior, que operación usamos para xuntar cantidades?',
      hintExpectLess: 'Pista: Se esperamos un resultado menor, que operación usamos para quitar unha cantidade?',
      lastSelected: 'Último número seleccionado:',
      sendAnswer: 'ENVIAR RESPOSTA',
      resetTable: '🔄 COMEZAR DE NOVO',
      yourAnswer: 'A túa resposta:',
      send: 'ENVIAR',
      wrongAnswer: 'Resposta incorrecta. Pensa máis ou usa outro método.',
      wrongAnswerLong: 'O número que seleccionaches non é a resposta correcta.',
      useHelpHint: '💡 Usa o botón "MOSTRAR AXUDA" para que te guiemos paso a paso ata a solución.',
      step: 'PASO',
      findNumber: 'Busca e fai clic no número',
      understood: 'ENTENDIDO',
      tableScreenBack: 'Volver',
      showHelp: 'MOSTRAR AXUDA',
      hideHelp: 'OCULTAR AXUDA',
      stepBack: 'ATRÁS',
      stepNext: 'SEGUINTE',
      lastClicked: 'Último número seleccionado',
      configuration: 'Configuración',
      problemCounter: 'Problema {current} de {total}',
      sessionComplete: 'Sesión Completada!',
      yourScore: 'A túa Puntuación',
      excellentWork: 'Excelente traballo, Detective Matemático!',
      missionComplete: 'Misión cumprida! Gañaches puntos de experiencia e medallas polo teu gran labor detectivesco ao resolver este caso.',
      newSession: 'Nova Sesión',
      backToHome: 'Volver ao Inicio',
      loading: 'Cargando aventura...',
      readProblem: 'Le o Problema',
      problemTextAudio: 'TEXTO/AUDIO do problema',
      startAdventure: 'COMEZAR A AVENTURA',
      previousStep: 'Paso Anterior',
      nextProblem: 'Seguinte Problema',
      finishSession: 'Finalizar Sesión',
      units: 'unidades',
      tableUnits: 'U',
      tableTens: 'D'
    }
  },
  'en-GB': {
    code: 'en-GB',
    name: 'English',
    nativeName: 'English',
    voice: { lang: 'en-GB', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'MATH DETECTIVES 1ST GRADE',
      welcome: 'Hello! Ready to put your knowledge into practice?',
      selectLanguage: 'LANGUAGE',
      start: 'START',
      home: 'HOME',
      exit: 'EXIT',
      contexts: 'Choose your math adventure',
      exitConfirm: 'Are you sure you want to exit?',

      configTitle: 'Configure Your Session',
      back: 'Back',
      previous: 'PREVIOUS',
      continue: 'CONTINUE',

      problemTypeTitle: 'What do you want to practice?',
      problemTypeAny: 'NEW MISSION',
      problemTypeAnyDesc: 'Math adventure with continuous storytelling',
      problemTypeSum: 'Addition',
      problemTypeSumDesc: 'Addition problems',
      problemTypeSubtraction: 'Subtraction',
      problemTypeSubtractionDesc: 'Subtraction problems',

      levelTitle: 'What kind of investigator are you?',
      levelBeginner: 'Beginner',
      levelBeginnerDesc: 'Numbers from 1 to 10',
      levelAdvanced: 'Advanced',
      levelAdvancedDesc: 'Numbers from 1 to 20',
      levelExpert: 'Expert',
      levelExpertDesc: 'Numbers from 1 to 50',

      contextTitle: 'Where does the adventure take place?',
      contextFilterAll: 'All',
      contextFilterSpecial: 'Special Moments',
      contextFilterShop: 'Shopping',
      contextFilterNature: 'Nature',
      contextFilterDaily: 'Daily Life',
      contextFilterPlaces: 'Places',

      tableSelectTitle: 'Select the number',
      close: 'Close',
      abnTitle: 'Number Grid Helper',
      abnCalculating: 'Calculating:',
      abnSteps: 'Steps:',
      abnPrev: 'Previous',
      abnNext: 'Next',
      abnUse: 'Use result',

      stepNavStep1: 'Upon completing each step, you will move to the next one, but if you wish, you can advance to a later step',
      stepNavMiddle: 'You can move forward or backward to any step you wish',
      stepNavLast: 'You can go back to any previous step you wish',

      // Wizard Step Labels
      wizardStep1Label: 'Understanding',
      wizardStep2Label: 'Highlighting',
      wizardStep3Label: 'Representation',
      wizardStep4Label: 'Reasoning',
      wizardStep5Label: 'Calculation',
      wizardStep6Label: 'Answer',
      wizardStep1Title: '📖 Step 1: Understanding',

      wizardStep1Question: 'Have you understood the problem?',
      wizardStep1Yes: '✓ Yes, I understand',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;A little help&quot; )">🔊</span> A little help',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;A little help&quot; )">🔊</span> 💡 A little help:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Questions&quot; )">🔊</span> ❓ 1. QUESTIONS',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Diagram&quot; )">🔊</span> 💡 2. DIAGRAM',
      wizardStep2Title: '✏️ Step 2: Highlighting',
      wizardStep2Instruction: 'Identify and mark the elements of the problem',
      highlightQuestion: 'Question',
      highlightUseful: 'Useful Data',
      highlightClear: '🗑️ Clear',
      validateHighlight: 'Validate Highlighting',
      wizardStep3Title: '📊 Step 3: Representation',
      wizardStep3Instruction: 'Represent the quantities with bars',
      barLabel: 'Bar {n}: Adjust to show {value} {element}',
      barInstruction: 'Move the red circle to reach the value {value}, as they are {value} {element}',
      validateRepresentation: 'Validate Representation',
      wizardStep4Title: '🤔 Step 4: Reasoning',
      wizardStep4Intro: 'Now, look at the largest of these quantities ({data}) and complete:',
      quantitiesReminder: '📊 Reminder of quantities:',
      largestDataLabel: 'The largest number related to the question is:',
      chooseLargest: '-- Choose the largest number --',
      rememberQuestion: 'Remember the question:',
      thinkAndAnswer: 'Now think and answer, will the final number of',
      willBeGreaterOrLess: 'be greater or less than',
      thanWord: 'than',
      chooseOption: '-- Choose --',
      optionGreater: 'GREATER',
      optionLess: 'LESS',
      validate: 'Validate',
      operationQuestion: 'Finally, decide which operation you need to perform to answer the question: Addition or Subtraction?',
      optionSum: 'ADDITION',
      optionSubtraction: 'SUBTRACTION',
      validateContinue: 'Validate and Continue',
      helpButton: 'HELP',
      helpText: 'Remember that if the expected result is greater than {value}, you should perform an ADDITION, but if the expected result is less than {value}, you should perform a SUBTRACTION.',
      wizardStep5Title: '🧮 Step 5: Calculation',
      wizardStep5Instruction: 'CHOOSE ONE OF THE 3 METHODS TO CALCULATE THE SOLUTION',
      method1Title: 'COMPLETE THIS MATH OPERATION BY FILLING IN THE TABLE',
      method2Title: 'SOLVE WITH THE NUMBER GRID',
      method3Title: 'CALCULATE MENTALLY AND SELECT',
      checkButton: 'CHECK',
      selectNumberBtn: 'Select number',
      solveWithTable: 'Solve using the number grid',
      successCorrect: 'CORRECT!',
      successFound: 'You found the answer',
      wizardStep6Title: '✍️ Step 6: Final Answer',
      wizardStep6Instruction: 'Write the complete answer',
      rememberOperation: 'Remember that you have',
      addedVerb: 'added',
      subtractedVerb: 'subtracted',
      thereforeAnswer: ', therefore, the answer is:',
      submitAnswer: 'Submit Answer',
      summaryLabel: '📝 Summary',
      summaryOperation: 'Operation:',
      summaryResult: 'Result:',
      goToCalcBtn: '🔢 Calculation',

      // Feedback Messages
      feedbackPerfect: 'Perfect!',
      feedbackVeryGood: 'Very good!',
      feedbackGreat: 'Great!',
      feedbackCorrect: 'Correct!',
      feedbackFantastic: 'Fantastic!',
      feedbackTableCorrect: 'The table is correct!',
      feedbackOperationCorrect: 'Correct operation! Now write the final answer.',
      feedbackTryHighlight: 'Try to mark the question and at least one useful piece of data.',
      feedbackHighlightQuestionMissing: 'Remember that the question is between the question marks (¿...? or ...?).',
      feedbackHighlightDataWrong: 'Review the useful data. Remember that they are the numbers or quantities related to the question being asked, in this case, they will be quantities of {element}.',
      feedbackHighlightBothWrong: 'Remember: the question is between the question marks (¿...? or ...?) and the useful data are the numbers related to the question.',
      feedbackSelectNumber: 'Please select one of the numbers.',
      feedbackSelectMagnitude: 'Please select whether it will be GREATER or LESS.',
      feedbackSelectOperation: 'Please select the operation (ADDITION or SUBTRACTION).',
      feedbackCompleteCalc: 'Complete the calculation using the table, the number selector, or the grid helper',
      feedbackCheckCalc: 'Check your calculation.',
      feedbackSelectResult: 'Please select a number for the result.',
      feedbackValuesAre: 'The values of the problem are {values}. Adjust the bars correctly.',
      feedbackNumberCorrectButName: 'The number {number} is correct, but check the object name. It should be "{name}".',
      feedbackNameCorrectButNumber: 'The name "{name}" is correct, but the number should be {number}.',
      feedbackCorrectAnswer: 'The correct answer was {answer} {element}. Keep trying!',

      // Hints
      hintLargestNumber: 'Hint: Which number is the largest? Compare: {values}.',
      hintSumResult: 'Hint: If we add two quantities, will the result be greater or less than each of them?',
      hintSubResult: 'Hint: If we subtract one quantity from another, will the result be greater or less than the original?',
      hintExpectGreater: 'Hint: If we expect a greater result, which operation do we use to combine quantities?',
      hintExpectLess: 'Hint: If we expect a smaller result, which operation do we use to remove a quantity?',

      // Numeric Table Screen
      lastSelected: 'Last number selected:',
      sendAnswer: 'SEND ANSWER',
      resetTable: '🔄 START OVER',
      yourAnswer: 'Your answer:',
      send: 'SEND',
      wrongAnswer: 'Wrong answer. Think more or use another method.',
      wrongAnswerLong: 'The number you selected is not the correct answer.',
      useHelpHint: '💡 Use the "SHOW HELP" button so we can guide you step by step to the solution.',
      step: 'STEP',
      findNumber: 'Find and click on the number',
      understood: 'UNDERSTOOD',
      tableScreenBack: 'Back',
      showHelp: 'SHOW HELP',
      hideHelp: 'HIDE HELP',
      stepBack: 'BACK',
      stepNext: 'NEXT',
      lastClicked: 'Last number selected',

      // Navigation
      configuration: 'Configuration',
      problemCounter: 'Problem {current} of {total}',
      sessionComplete: 'Session Complete!',
      yourScore: 'Your Score',
      excellentWork: 'Excellent work, Math Detective!',
      missionComplete: 'Mission accomplished! Your excellent detective work solving this case has earned you experience points and medals. But wait... I just found some strange footprints near the door. It seems we have a new mystery to solve soon!',
      newSession: 'New Session',
      backToHome: 'Back to Home',
      loading: 'Loading adventure...',
      readProblem: 'Read the Problem',
      problemTextAudio: 'Problem TEXT/AUDIO',
      startAdventure: 'START THE ADVENTURE',
      previousStep: 'Previous Step',
      nextProblem: 'Next Problem',
      finishSession: 'Finish Session',
      units: 'units',
      tableUnits: 'U',
      tableTens: 'T'
    }
  },
  'fr-FR': {
    code: 'fr-FR',
    name: 'Français',
    nativeName: 'Français',
    voice: { lang: 'fr-FR', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'DÉTECTIVES MATHÉMATIQUES DE 1ÈRE',
      welcome: 'Bonjour! Prêt à mettre en pratique tes connaissances?',
      selectLanguage: 'LANGUE',
      start: 'COMMENCER',
      exit: 'SORTIR',
      contexts: 'Choisis ton aventure mathématique',
      exitConfirm: 'Es-tu sûr de vouloir quitter?',
      configTitle: 'Configure ta Session',
      back: 'Retour',
      previous: 'PRÉCÉDENT',
      continue: 'CONTINUER',
      problemTypeTitle: 'Que veux-tu pratiquer?',
      problemTypeAny: 'Addition ou Soustraction',
      problemTypeAnyDesc: 'Mélange de problèmes d\'addition ou soustraction',
      problemTypeSum: 'Addition',
      problemTypeSumDesc: 'Problèmes d\'addition',
      problemTypeSubtraction: 'Soustraction',
      problemTypeSubtractionDesc: 'Problèmes de soustraction',
      levelTitle: 'Quel est ton niveau?',
      levelBeginner: 'Débutant',
      levelBeginnerDesc: 'Nombres de 1 à 10',
      levelAdvanced: 'Avancé',
      levelAdvancedDesc: 'Nombres de 1 à 20',
      levelExpert: 'Expert',
      levelExpertDesc: 'Nombres de 1 à 50',
      contextTitle: 'Où se déroule l\'aventure?',
      contextFilterAll: 'Tous',
      contextFilterSpecial: 'Moments Spéciaux',
      contextFilterShop: 'Achats',
      contextFilterNature: 'Nature',
      contextFilterDaily: 'Quotidien',
      contextFilterPlaces: 'Lieux',

      tableSelectTitle: 'Sélectionnez le numéro',
      close: 'Fermer',
      abnTitle: 'Aide grille numérique',
      abnCalculating: 'Calcul:',
      abnSteps: 'Étapes:',
      abnPrev: 'Précédent',
      abnNext: 'Suivant',
      abnUse: 'Utiliser résultat',

      stepNavStep1: 'En terminant chaque étape, vous passerez à la suivante, mais si vous le souhaitez, vous pouvez avancer à une étape ultérieure',
      stepNavMiddle: 'Vous pouvez avancer ou reculer à l\'étape que vous souhaitez',
      stepNavLast: 'Vous pouvez revenir à l\'étape que vous souhaitez',

      wizardStep1Label: 'Compréhension',
      wizardStep2Label: 'Soulignement',
      wizardStep3Label: 'Représentation',
      wizardStep4Label: 'Raisonnement',
      wizardStep5Label: 'Calcul',
      wizardStep6Label: 'Réponse',
      wizardStep1Title: '📖 Étape 1: Compréhension',
      wizardStep1Instruction: 'Lis le problème attentivement. Tu le comprends?',
      wizardStep1Question: 'As-tu compris le problème?',
      wizardStep1Yes: '✓ Oui, je comprends',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un peu d\'aide&quot; )">🔊</span> Un peu d\'aide',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un peu d\'aide&quot; )">🔊</span> 💡 Un peu d\'aide:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Questions&quot; )">🔊</span> ❓ 1. QUESTIONS',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Schéma&quot; )">🔊</span> 💡 2. SCHÉMA',
      wizardStep2Title: '✏️ Étape 2: Soulignement',
      wizardStep2Instruction: 'Identifie et marque les éléments du problème',
      highlightQuestion: 'Question',
      highlightUseful: 'Données Utiles',
      highlightClear: '🗑️ Effacer',
      validateHighlight: 'Valider le Soulignement',
      wizardStep3Title: '📊 Étape 3: Représentation',
      wizardStep3Instruction: 'Représente les quantités avec des barres',
      barLabel: 'Barre {n}: Ajuste pour montrer {value} {element}',
      barInstruction: 'Déplace le cercle rouge jusqu\'à atteindre la valeur {value}, car ils sont {value} {element}',
      validateRepresentation: 'Valider la Représentation',
      wizardStep4Title: '🤔 Étape 4: Raisonnement',
      wizardStep4Intro: 'Maintenant, regarde la plus grande de ces quantités ({data}) et complète:',
      quantitiesReminder: '📊 Rappel des quantités:',
      largestDataLabel: 'Le plus grand nombre lié à la question est:',
      chooseLargest: '-- Choisis le plus grand nombre --',
      rememberQuestion: 'Rappelle-toi la question:',
      thinkAndAnswer: 'Maintenant réfléchis et réponds, à la fin, le nombre de',
      willBeGreaterOrLess: 'sera plus grand ou plus petit que',
      thanWord: 'que',
      chooseOption: '-- Choisis --',
      optionGreater: 'PLUS GRAND',
      optionLess: 'PLUS PETIT',
      validate: 'Valider',
      operationQuestion: 'Enfin, décide quelle opération tu dois faire pour répondre: Addition ou Soustraction?',
      optionSum: 'ADDITION',
      optionSubtraction: 'SOUSTRACTION',
      validateContinue: 'Valider et Continuer',
      helpButton: 'AIDE',
      helpText: 'Rappelle-toi que si le résultat attendu est plus grand que {value}, tu dois faire une ADDITION, mais si le résultat attendu est plus petit que {value}, tu dois faire une SOUSTRACTION.',
      wizardStep5Title: '🧮 Étape 5: Calcul',
      wizardStep5Instruction: 'CHOISIS L\'UNE DES 3 MÉTHODES POUR CALCULER LA SOLUTION',
      method1Title: 'RÉALISE CETTE OPÉRATION MATHÉMATIQUE EN COMPLÉTANT LE TABLEAU',
      method2Title: 'RÉSOUS AVEC LA GRILLE NUMÉRIQUE',
      method3Title: 'CALCULE MENTALEMENT ET SÉLECTIONNE',
      checkButton: 'VÉRIFIER',
      selectNumberBtn: 'Sélectionner un nombre',
      solveWithTable: 'Résoudre avec la grille numérique',
      successCorrect: 'CORRECT!',
      successFound: 'Tu as trouvé la réponse',
      wizardStep6Title: '✍️ Étape 6: Réponse Finale',
      wizardStep6Instruction: 'Écris la réponse complète',
      rememberOperation: 'Rappelle-toi que tu as',
      addedVerb: 'additionné',
      subtractedVerb: 'soustrait',
      thereforeAnswer: ', donc, la réponse est:',
      submitAnswer: 'Envoyer la Réponse',
      summaryLabel: '📝 Résumé',
      summaryOperation: 'Opération:',
      summaryResult: 'Résultat:',
      goToCalcBtn: '🔢 Calcul',
      feedbackPerfect: 'Parfait!',
      feedbackVeryGood: 'Très bien!',
      feedbackGreat: 'Génial!',
      feedbackCorrect: 'Correct!',
      feedbackFantastic: 'Fantastique!',
      feedbackTableCorrect: 'Le tableau est correct!',
      feedbackOperationCorrect: 'Opération correcte! Maintenant écris la réponse finale.',
      feedbackTryHighlight: 'Essaie de marquer la question et au moins une donnée utile.',
      feedbackHighlightQuestionMissing: 'Rappelle-toi que la question est entre les points d\'interrogation (¿...?).',
      feedbackHighlightDataWrong: 'Révise les données utiles. Ce sont les nombres ou quantités de {element} liés à la question, avec lesquels tu devras opérer.',
      feedbackHighlightBothWrong: 'Rappelle-toi: la question est entre les points d\'interrogation (¿...?) et les données utiles sont les nombres liés à la question.',
      feedbackSelectNumber: 'S\'il te plaît, sélectionne l\'un des nombres.',
      feedbackSelectMagnitude: 'S\'il te plaît, sélectionne si ce sera PLUS GRAND ou PLUS PETIT.',
      feedbackSelectOperation: 'S\'il te plaît, sélectionne l\'opération (ADDITION ou SOUSTRACTION).',
      feedbackCompleteCalc: 'Complète le calcul avec le tableau, le sélecteur ou l\'aide',
      feedbackCheckCalc: 'Vérifie ton calcul.',
      feedbackSelectResult: 'S\'il te plaît, sélectionne un nombre pour le résultat.',
      feedbackValuesAre: 'Les valeurs du problème sont {values}. Ajuste les barres correctement.',
      feedbackNumberCorrectButName: 'Le nombre {number} est correct, mais vérifie le nom de l\'objet. Ça doit être "{name}".',
      feedbackNameCorrectButNumber: 'Le nom "{name}" est correct, mais le nombre devrait être {number}.',
      feedbackCorrectAnswer: 'La bonne réponse était {answer} {element}. Continue d\'essayer!',
      hintLargestNumber: 'Indice: Quel nombre est le plus grand? Compare: {values}.',
      hintSumResult: 'Indice: Si on additionne deux quantités, le résultat sera plus grand ou plus petit que chacune?',
      hintSubResult: 'Indice: Si on soustrait une quantité d\'une autre, le résultat sera plus grand ou plus petit que l\'original?',
      hintExpectGreater: 'Indice: Si on attend un résultat plus grand, quelle opération utilise-t-on pour combiner?',
      hintExpectLess: 'Indice: Si on attend un résultat plus petit, quelle opération utilise-t-on pour enlever?',
      lastSelected: 'Dernier nombre sélectionné:',
      sendAnswer: 'ENVOYER LA RÉPONSE',
      resetTable: '🔄 RECOMMENCER',
      yourAnswer: 'Ta réponse:',
      send: 'ENVOYER',
      wrongAnswer: 'Mauvaise réponse. Réfléchis plus ou utilise une autre méthode.',
      wrongAnswerLong: 'Le nombre que tu as sélectionné n\'est pas la bonne réponse.',
      useHelpHint: '💡 Utilise le bouton "AFFICHER L\'AIDE" pour qu\'on te guide étape par étape.',
      step: 'ÉTAPE',
      findNumber: 'Trouve et clique sur le nombre',
      understood: 'COMPRIS',
      tableScreenBack: 'Retour',
      showHelp: 'AFFICHER L\'AIDE',
      hideHelp: 'CACHER L\'AIDE',
      stepBack: 'RETOUR',
      stepNext: 'SUIVANT',
      lastClicked: 'Dernier nombre sélectionné',
      configuration: 'Configuration',
      problemCounter: 'Problème {current} sur {total}',
      sessionComplete: 'Session Terminée!',
      yourScore: 'Ton Score',
      excellentWork: 'Excellent travail, Détective Mathématique!',
      newSession: 'Nouvelle Session',
      backToHome: 'Retour à l\'Accueil',
      loading: 'Chargement de l\'aventure...',
      readProblem: 'Lis le Problème',
      problemTextAudio: 'TEXTE/AUDIO du problème',
      startAdventure: 'COMMENCER L\'AVENTURE',
      previousStep: 'Étape Précédente',
      nextProblem: 'Problème Suivant',
      finishSession: 'Terminer la Session',
      units: 'unités',
      tableUnits: 'U',
      tableTens: 'D'
    }
  },
  'de-DE': {
    code: 'de-DE',
    name: 'Deutsch',
    nativeName: 'Deutsch',
    voice: { lang: 'de-DE', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'MATHE-DETEKTIVE 1. KLASSE',
      welcome: 'Hallo! Bereit, dein Wissen in die Praxis umzusetzen?',
      selectLanguage: 'SPRACHE',
      start: 'START',
      exit: 'BEENDEN',
      contexts: 'Wähle dein Mathe-Abenteuer',
      exitConfirm: 'Bist du sicher, dass du beenden möchtest?',
      configTitle: 'Konfiguriere deine Sitzung',
      back: 'Zurück',
      previous: 'ZURÜCK',
      continue: 'WEITER',
      problemTypeTitle: 'Was möchtest du üben?',
      problemTypeAny: 'Addition oder Subtraktion',
      problemTypeAnyDesc: 'Mix aus Additions- oder Subtraktionsproblemen',
      problemTypeSum: 'Addition',
      problemTypeSumDesc: 'Additionsprobleme',
      problemTypeSubtraction: 'Subtraktion',
      problemTypeSubtractionDesc: 'Subtraktionsprobleme',
      levelTitle: 'Welches Niveau hast du?',
      levelBeginner: 'Anfänger',
      levelBeginnerDesc: 'Zahlen von 1 bis 10',
      levelAdvanced: 'Fortgeschritten',
      levelAdvancedDesc: 'Zahlen von 1 bis 20',
      levelExpert: 'Experte',
      levelExpertDesc: 'Zahlen von 1 bis 50',
      contextTitle: 'Wo findet das Abenteuer statt?',
      contextFilterAll: 'Alle',
      contextFilterSpecial: 'Besondere Momente',
      contextFilterShop: 'Einkaufen',
      contextFilterNature: 'Natur',
      contextFilterDaily: 'Alltag',
      contextFilterPlaces: 'Orte',

      tableSelectTitle: 'Wähle die Nummer',
      close: 'Schließen',
      abnTitle: 'Zahlentabelle Hilfe',
      abnCalculating: 'Berechnung:',
      abnSteps: 'Schritte:',
      abnPrev: 'Zurück',
      abnNext: 'Weiter',
      abnUse: 'Ergebnis verwenden',

      stepNavStep1: 'Nach Abschluss jedes Schritts gehen Sie zum nächsten über, aber wenn Sie möchten, können Sie zu einem späteren Schritt vorrücken',
      stepNavMiddle: 'Sie können zu jedem gewünschten Schritt vor- oder zurückgehen',
      stepNavLast: 'Sie können zu jedem vorherigen Schritt zurückkehren',

      wizardStep1Label: 'Verstehen',
      wizardStep2Label: 'Markieren',
      wizardStep3Label: 'Darstellung',
      wizardStep4Label: 'Begründung',
      wizardStep5Label: 'Berechnung',
      wizardStep6Label: 'Antwort',
      wizardStep1Title: '📖 Schritt 1: Verstehen',
      wizardStep1Instruction: 'Lies das Problem aufmerksam. Verstehst du es?',
      wizardStep1Question: 'Hast du das Problem verstanden?',
      wizardStep1Yes: '✓ Ja, ich verstehe',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Ein bisschen Hilfe&quot; )">🔊</span> Ein bisschen Hilfe',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Ein bisschen Hilfe&quot; )">🔊</span> 💡 Ein bisschen Hilfe:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Fragen&quot; )">🔊</span> ❓ 1. FRAGEN',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Schema&quot; )">🔊</span> 💡 2. SCHEMA',
      wizardStep2Title: '✏️ Schritt 2: Markieren',
      wizardStep2Instruction: 'Identifiziere und markiere die Elemente des Problems',
      highlightQuestion: 'Frage',
      highlightUseful: 'Nützliche Daten',
      highlightClear: '🗑️ Löschen',
      validateHighlight: 'Markierung Validieren',
      wizardStep3Title: '📊 Schritt 3: Darstellung',
      wizardStep3Instruction: 'Stelle die Mengen mit Balken dar',
      barLabel: 'Balken {n}: Anpassen um {value} {element} zu zeigen',
      barInstruction: 'Verschiebe den roten Kreis, um den Wert {value} zu erreichen, da es {value} {element} sind',
      validateRepresentation: 'Darstellung Validieren',
      wizardStep4Title: '🤔 Schritt 4: Begründung',
      wizardStep4Intro: 'Jetzt schau auf die größte dieser Mengen ({data}) und vervollständige:',
      quantitiesReminder: '📊 Erinnerung an die Mengen:',
      largestDataLabel: 'Die größte Zahl zur Frage ist:',
      chooseLargest: '-- Wähle die größte Zahl --',
      rememberQuestion: 'Erinnere dich an die Frage:',
      thinkAndAnswer: 'Jetzt denke und antworte, wird die Anzahl von',
      willBeGreaterOrLess: 'am Ende größer oder kleiner sein als',
      thanWord: 'als',
      chooseOption: '-- Wähle --',
      optionGreater: 'GRÖSSER',
      optionLess: 'KLEINER',
      validate: 'Validieren',
      operationQuestion: 'Zum Schluss entscheide welche Operation du machen musst: Addition oder Subtraktion?',
      optionSum: 'ADDITION',
      optionSubtraction: 'SUBTRAKTION',
      validateContinue: 'Validieren und Weiter',
      helpButton: 'HILFE',
      helpText: 'Denke daran, wenn das erwartete Ergebnis größer als {value} ist, musst du eine ADDITION machen, aber wenn das erwartete Ergebnis kleiner als {value} ist, musst du eine SUBTRAKTION machen.',
      wizardStep5Title: '🧮 Schritt 5: Berechnung',
      wizardStep5Instruction: 'WÄHLE EINE DER 3 METHODEN ZUR BERECHNUNG',
      method1Title: 'FÜHRE DIESE RECHENOPERATION DURCH',
      method2Title: 'LÖSE MIT DEM ZAHLENGITTER',
      method3Title: 'RECHNE IM KOPF UND WÄHLE',
      checkButton: 'PRÜFEN',
      selectNumberBtn: 'Zahl auswählen',
      solveWithTable: 'Mit Zahlengitter lösen',
      successCorrect: 'RICHTIG!',
      successFound: 'Du hast die Antwort gefunden',
      wizardStep6Title: '✍️ Schritt 6: Endantwort',
      wizardStep6Instruction: 'Schreibe die vollständige Antwort',
      rememberOperation: 'Denke daran, du hast',
      addedVerb: 'addiert',
      subtractedVerb: 'subtrahiert',
      thereforeAnswer: ', also ist die Antwort:',
      submitAnswer: 'Antwort Senden',
      summaryLabel: '📝 Zusammenfassung',
      summaryOperation: 'Operation:',
      summaryResult: 'Ergebnis:',
      goToCalcBtn: '🔢 Berechnung',
      feedbackPerfect: 'Perfekt!',
      feedbackVeryGood: 'Sehr gut!',
      feedbackGreat: 'Super!',
      feedbackCorrect: 'Richtig!',
      feedbackFantastic: 'Fantastisch!',
      feedbackTableCorrect: 'Die Tabelle ist richtig!',
      feedbackOperationCorrect: 'Richtige Operation! Jetzt schreibe die Endantwort.',
      feedbackTryHighlight: 'Versuche die Frage und mindestens ein nützliches Datum zu markieren.',
      feedbackHighlightQuestionMissing: 'Denke daran, dass die Frage zwischen den Fragezeichen steht (¿...?).',
      feedbackHighlightDataWrong: 'Überprüfe die nützlichen Daten. Das sind die Zahlen oder Mengen von {element}, die mit der Frage zusammenhängen und mit denen du operieren musst.',
      feedbackHighlightBothWrong: 'Denke daran: die Frage steht zwischen den Fragezeichen (¿...?) und die nützlichen Daten sind die Zahlen, die mit der Frage zusammenhängen.',
      feedbackSelectNumber: 'Bitte wähle eine der Zahlen.',
      feedbackSelectMagnitude: 'Bitte wähle ob es GRÖSSER oder KLEINER sein wird.',
      feedbackSelectOperation: 'Bitte wähle die Operation (ADDITION oder SUBTRAKTION).',
      feedbackCompleteCalc: 'Vervollständige die Berechnung mit der Tabelle, dem Zahlenwähler oder der Hilfe',
      feedbackCheckCalc: 'Überprüfe deine Berechnung.',
      feedbackSelectResult: 'Bitte wähle eine Zahl für das Ergebnis.',
      feedbackValuesAre: 'Die Werte des Problems sind {values}. Passe die Balken richtig an.',
      feedbackNumberCorrectButName: 'Die Zahl {number} ist richtig, aber überprüfe den Objektnamen. Er sollte "{name}" sein.',
      feedbackNameCorrectButNumber: 'Der Name "{name}" ist richtig, aber die Zahl sollte {number} sein.',
      feedbackCorrectAnswer: 'Die richtige Antwort war {answer} {element}. Weiter versuchen!',
      hintLargestNumber: 'Hinweis: Welche Zahl ist die größte? Vergleiche: {values}.',
      hintSumResult: 'Hinweis: Wenn wir zwei Mengen addieren, wird das Ergebnis größer oder kleiner als jede einzelne?',
      hintSubResult: 'Hinweis: Wenn wir eine Menge von einer anderen subtrahieren, wird das Ergebnis größer oder kleiner als das Original?',
      hintExpectGreater: 'Hinweis: Wenn wir ein größeres Ergebnis erwarten, welche Operation benutzen wir zum Kombinieren?',
      hintExpectLess: 'Hinweis: Wenn wir ein kleineres Ergebnis erwarten, welche Operation benutzen wir zum Entfernen?',
      lastSelected: 'Zuletzt gewählte Zahl:',
      sendAnswer: 'ANTWORT SENDEN',
      resetTable: '🔄 NEU STARTEN',
      yourAnswer: 'Deine Antwort:',
      send: 'SENDEN',
      wrongAnswer: 'Falsche Antwort. Denke mehr nach oder benutze eine andere Methode.',
      wrongAnswerLong: 'Die gewählte Zahl ist nicht die richtige Antwort.',
      useHelpHint: '💡 Benutze den "HILFE ZEIGEN" Knopf für schrittweise Anleitung.',
      step: 'SCHRITT',
      findNumber: 'Finde und klicke auf die Zahl',
      understood: 'VERSTANDEN',
      tableScreenBack: 'Zurück',
      showHelp: 'HILFE ZEIGEN',
      hideHelp: 'HILFE VERSTECKEN',
      stepBack: 'ZURÜCK',
      stepNext: 'WEITER',
      lastClicked: 'Zuletzt gewählte Zahl',
      configuration: 'Konfiguration',
      problemCounter: 'Aufgabe {current} von {total}',
      sessionComplete: 'Sitzung Abgeschlossen!',
      yourScore: 'Deine Punktzahl',
      excellentWork: 'Ausgezeichnete Arbeit, Mathe-Detektiv!',
      missionComplete: 'Mission abgeschlossen! Du hast Erfahrungspunkte und Medaillen für deine großartige Detektivarbeit bei der Lösung dieses Falls verdient.',
      newSession: 'Neue Sitzung',
      backToHome: 'Zurück zur Startseite',
      loading: 'Abenteuer wird geladen...',
      readProblem: 'Lies das Problem',
      problemTextAudio: 'Problem TEXT/AUDIO',
      startAdventure: 'ABENTEUER STARTEN',
      previousStep: 'Vorheriger Schritt',
      nextProblem: 'Nächstes Problem',
      finishSession: 'Sitzung Beenden',
      units: 'Einheiten',
      tableUnits: 'E',
      tableTens: 'Z'
    }
  },
  'it-IT': {
    code: 'it-IT',
    name: 'Italiano',
    nativeName: 'Italiano',
    voice: { lang: 'it-IT', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'DETECTIVE MATEMATICI DI 1°',
      welcome: 'Ciao! Pronto a mettere in pratica le tue conoscenze?',
      selectLanguage: 'LINGUA',
      start: 'INIZIA',
      exit: 'ESCI',
      contexts: 'Scegli la tua avventura matematica',
      exitConfirm: 'Sei sicuro di voler uscire?',
      configTitle: 'Configura la tua Sessione',
      back: 'Indietro',
      previous: 'PRECEDENTE',
      continue: 'CONTINUA',
      problemTypeTitle: 'Cosa vuoi praticare?',
      problemTypeAny: 'Addizione o Sottrazione',
      problemTypeAnyDesc: 'Mix di problemi di addizione o sottrazione',
      problemTypeSum: 'Addizione',
      problemTypeSumDesc: 'Problemi di addizione',
      problemTypeSubtraction: 'Sottrazione',
      problemTypeSubtractionDesc: 'Problemi di sottrazione',
      levelTitle: 'Che livello sei?',
      levelBeginner: 'Principiante',
      levelBeginnerDesc: 'Numeri da 1 a 10',
      levelAdvanced: 'Avanzato',
      levelAdvancedDesc: 'Numeri da 1 a 20',
      levelExpert: 'Esperto',
      levelExpertDesc: 'Numeri da 1 a 50',
      contextTitle: 'Dove si svolge l\'avventura?',
      contextFilterAll: 'Tutti',
      contextFilterSpecial: 'Momenti Speciali',
      contextFilterShop: 'Acquisti',
      contextFilterNature: 'Natura',
      contextFilterDaily: 'Quotidiano',
      contextFilterPlaces: 'Luoghi',

      tableSelectTitle: 'Seleziona il numero',
      close: 'Chiudi',
      abnTitle: 'Aiuto Tabella Numerica',
      abnCalculating: 'Calcolo:',
      abnSteps: 'Passi:',
      abnPrev: 'Precedente',
      abnNext: 'Successivo',
      abnUse: 'Usa risultato',

      stepNavStep1: 'Completando ogni passo, passerai al successivo, ma se lo desideri, puoi avanzare a un passo successivo',
      stepNavMiddle: 'Puoi avanzare o tornare indietro al passo che desideri',
      stepNavLast: 'Puoi tornare indietro al passo che desideri',

      wizardStep1Label: 'Comprensione',
      wizardStep2Label: 'Sottolineatura',
      wizardStep3Label: 'Rappresentazione',
      wizardStep4Label: 'Ragionamento',
      wizardStep5Label: 'Calcolo',
      wizardStep6Label: 'Risposta',
      wizardStep1Title: '📖 Passo 1: Comprensione',
      wizardStep1Instruction: 'Leggi il problema con attenzione. Lo capisci?',
      wizardStep1Question: 'Hai capito il problema?',
      wizardStep1Yes: '✓ Sì, capisco',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un po\' di aiuto&quot; )">🔊</span> Un po\' di aiuto',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Un po\' di aiuto&quot; )">🔊</span> 💡 Un po\' di aiuto:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Domande&quot; )">🔊</span> ❓ 1. DOMANDE',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Schema&quot; )">🔊</span> 💡 2. SCHEMA',
      wizardStep2Title: '✏️ Passo 2: Sottolineatura',
      wizardStep2Instruction: 'Identifica e segna gli elementi del problema',
      highlightQuestion: 'Domanda',
      highlightUseful: 'Dati Utili',
      highlightClear: '🗑️ Cancella',
      validateHighlight: 'Valida Sottolineatura',
      wizardStep3Title: '📊 Passo 3: Rappresentazione',
      wizardStep3Instruction: 'Rappresenta le quantità con le barre',
      barLabel: 'Barra {n}: Regola per mostrare {value} {element}',
      barInstruction: 'Sposta il cerchio rosso fino a raggiungere il valore {value}, poiché sono {value} {element}',
      validateRepresentation: 'Valida Rappresentazione',
      wizardStep4Title: '🤔 Passo 4: Ragionamento',
      wizardStep4Intro: 'Ora, guarda la maggiore di queste quantità ({data}) e completa:',
      quantitiesReminder: '📊 Promemoria delle quantità:',
      largestDataLabel: 'Il numero maggiore legato alla domanda è:',
      chooseLargest: '-- Scegli il numero maggiore --',
      rememberQuestion: 'Ricorda la domanda:',
      thinkAndAnswer: 'Ora pensa e rispondi, alla fine, il numero di',
      willBeGreaterOrLess: 'sarà maggiore o minore di',
      thanWord: 'di',
      chooseOption: '-- Scegli --',
      optionGreater: 'MAGGIORE',
      optionLess: 'MINORE',
      validate: 'Valida',
      operationQuestion: 'Infine, decidi quale operazione devi fare per rispondere: Addizione o Sottrazione?',
      optionSum: 'ADDIZIONE',
      optionSubtraction: 'SOTTRAZIONE',
      validateContinue: 'Valida e Continua',
      helpButton: 'AIUTO',
      helpText: 'Ricorda che se il risultato atteso è maggiore di {value}, devi fare un\'ADDIZIONE, ma se il risultato atteso è minore di {value}, devi fare una SOTTRAZIONE.',
      wizardStep5Title: '🧮 Passo 5: Calcolo',
      wizardStep5Instruction: 'SCEGLI UNO DEI 3 METODI PER CALCOLARE LA SOLUZIONE',
      method1Title: 'ESEGUI QUESTA OPERAZIONE MATEMATICA COMPLETANDO LA TABELLA',
      method2Title: 'RISOLVI CON LA GRIGLIA NUMERICA',
      method3Title: 'CALCOLA MENTALMENTE E SELEZIONA',
      checkButton: 'VERIFICA',
      selectNumberBtn: 'Seleziona numero',
      solveWithTable: 'Risolvere con la griglia numerica',
      successCorrect: 'CORRETTO!',
      successFound: 'Hai trovato la risposta',
      wizardStep6Title: '✍️ Passo 6: Risposta Finale',
      wizardStep6Instruction: 'Scrivi la risposta completa',
      rememberOperation: 'Ricorda che hai',
      addedVerb: 'addizionato',
      subtractedVerb: 'sottratto',
      thereforeAnswer: ', quindi, la risposta è:',
      submitAnswer: 'Invia Risposta',
      summaryLabel: '📝 Riepilogo',
      summaryOperation: 'Operazione:',
      summaryResult: 'Risultato:',
      goToCalcBtn: '🔢 Calcolo',
      feedbackPerfect: 'Perfetto!',
      feedbackVeryGood: 'Molto bene!',
      feedbackGreat: 'Ottimo!',
      feedbackCorrect: 'Corretto!',
      feedbackFantastic: 'Fantastico!',
      feedbackTableCorrect: 'La tabella è corretta!',
      feedbackOperationCorrect: 'Operazione corretta! Ora scrivi la risposta finale.',
      feedbackTryHighlight: 'Prova a segnare la domanda e almeno un dato utile.',
      feedbackHighlightQuestionMissing: 'Ricorda che la domanda è tra i punti interrogativi (¿...?).',
      feedbackHighlightDataWrong: 'Rivedi i dati utili. Sono i numeri o le quantità di {element} correlati alla domanda, con cui dovrai operare.',
      feedbackHighlightBothWrong: 'Ricorda: la domanda è tra i punti interrogativi (¿...?) e i dati utili sono i numeri correlati alla domanda.',
      feedbackSelectNumber: 'Per favore, seleziona uno dei numeri.',
      feedbackSelectMagnitude: 'Per favore, seleziona se sarà MAGGIORE o MINORE.',
      feedbackSelectOperation: 'Per favore, seleziona l\'operazione (ADDIZIONE o SOTTRAZIONE).',
      feedbackCompleteCalc: 'Completa il calcolo usando la tabella, il selettore numerico o l\'aiuto',
      feedbackCheckCalc: 'Controlla il tuo calcolo.',
      feedbackSelectResult: 'Per favore, seleziona un numero per il risultato.',
      feedbackValuesAre: 'I valori del problema sono {values}. Regola le barre correttamente.',
      feedbackNumberCorrectButName: 'Il numero {number} è corretto, ma controlla il nome dell\'oggetto. Deve essere "{name}".',
      feedbackNameCorrectButNumber: 'Il nome "{name}" è corretto, ma il numero dovrebbe essere {number}.',
      feedbackCorrectAnswer: 'La risposta corretta era {answer} {element}. Continua a provare!',
      hintLargestNumber: 'Suggerimento: Qual è il numero maggiore? Confronta: {values}.',
      hintSumResult: 'Suggerimento: Se sommiamo due quantità, il risultato sarà maggiore o minore di ciascuna?',
      hintSubResult: 'Suggerimento: Se sottraiamo una quantità da un\'altra, il risultato sarà maggiore o minore dell\'originale?',
      hintExpectGreater: 'Suggerimento: Se ci aspettiamo un risultato maggiore, quale operazione usiamo per combinare?',
      hintExpectLess: 'Suggerimento: Se ci aspettiamo un risultato minore, quale operazione usiamo per togliere?',
      lastSelected: 'Ultimo numero selezionato:',
      sendAnswer: 'INVIA RISPOSTA',
      resetTable: '🔄 RICOMINCIA',
      yourAnswer: 'La tua risposta:',
      send: 'INVIA',
      wrongAnswer: 'Risposta sbagliata. Pensa di più o usa un altro metodo.',
      wrongAnswerLong: 'Il numero che hai selezionato non è la risposta corretta.',
      useHelpHint: '💡 Usa il pulsante "MOSTRA AIUTO" per essere guidato passo dopo passo.',
      step: 'PASSO',
      findNumber: 'Trova e clicca sul numero',
      understood: 'CAPITO',
      tableScreenBack: 'Indietro',
      showHelp: 'MOSTRA AIUTO',
      hideHelp: 'NASCONDI AIUTO',
      stepBack: 'INDIETRO',
      stepNext: 'AVANTI',
      lastClicked: 'Ultimo numero selezionato',
      configuration: 'Configurazione',
      problemCounter: 'Problema {current} di {total}',
      sessionComplete: 'Sessione Completata!',
      yourScore: 'Il tuo Punteggio',
      excellentWork: 'Eccellente lavoro, Detective Matematico!',
      missionComplete: 'Missione compiuta! Hai guadagnato punti esperienza e medaglie per il tuo grande lavoro investigativo nel risolvere questo caso.',
      newSession: 'Nuova Sessione',
      backToHome: 'Torna alla Home',
      loading: 'Caricamento avventura...',
      readProblem: 'Leggi il Problema',
      problemTextAudio: 'TESTO/AUDIO del problema',
      startAdventure: 'INIZIA L\'AVVENTURA',
      previousStep: 'Passo Precedente',
      nextProblem: 'Problema Successivo',
      finishSession: 'Termina Sessione',
      units: 'unità',
      tableUnits: 'U',
      tableTens: 'D'
    }
  },
  'pt-PT': {
    code: 'pt-PT',
    name: 'Português',
    nativeName: 'Português',
    voice: { lang: 'pt-PT', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'DETETIVES MATEMÁTICOS DO 1º',
      welcome: 'Olá! Pronto para colocar os teus conhecimentos em prática?',
      selectLanguage: 'IDIOMA',
      start: 'COMEÇAR',
      exit: 'SAIR',
      contexts: 'Escolhe a tua aventura matemática',
      exitConfirm: 'Tens a certeza de que queres sair?',
      configTitle: 'Configura a tua Sessão',
      back: 'Voltar',
      previous: 'ANTERIOR',
      continue: 'CONTINUAR',
      problemTypeTitle: 'O que queres praticar?',
      problemTypeAny: 'Adição ou Subtração',
      problemTypeAnyDesc: 'Mistura de problemas de adição ou subtração',
      problemTypeSum: 'Adição',
      problemTypeSumDesc: 'Problemas de adição',
      problemTypeSubtraction: 'Subtração',
      problemTypeSubtractionDesc: 'Problemas de subtração',
      levelTitle: 'Que nível tens?',
      levelBeginner: 'Iniciante',
      levelBeginnerDesc: 'Números de 1 a 10',
      levelAdvanced: 'Avançado',
      levelAdvancedDesc: 'Números de 1 a 20',
      levelExpert: 'Especialista',
      levelExpertDesc: 'Números de 1 a 50',
      contextTitle: 'Onde decorre a aventura?',
      contextFilterAll: 'Todos',
      contextFilterSpecial: 'Momentos Especiais',
      contextFilterShop: 'Compras',
      contextFilterNature: 'Natureza',
      contextFilterDaily: 'Diário',
      contextFilterPlaces: 'Lugares',

      tableSelectTitle: 'Selecione o número',
      close: 'Fechar',
      abnTitle: 'Ajuda Tabela Numérica',
      abnCalculating: 'Calculando:',
      abnSteps: 'Passos:',
      abnPrev: 'Anterior',
      abnNext: 'Seguinte',
      abnUse: 'Usar resultado',

      stepNavStep1: 'Ao completar cada passo, passará para o seguinte, mas se desejar, pode avançar para um passo posterior',
      stepNavMiddle: 'Pode avançar ou retroceder para o passo que desejar',
      stepNavLast: 'Pode retroceder para o passo que desejar',

      wizardStep1Label: 'Compreensão',
      wizardStep2Label: 'Sublinhado',
      wizardStep3Label: 'Representação',
      wizardStep4Label: 'Raciocínio',
      wizardStep5Label: 'Cálculo',
      wizardStep6Label: 'Resposta',
      wizardStep1Title: '📖 Passo 1: Compreensão',
      wizardStep1Instruction: 'Lê o problema com atenção. Compreendes?',
      wizardStep1Question: 'Compreendeste o problema?',
      wizardStep1Yes: '✓ Sim, compreendo',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Um pouco de ajuda&quot; )">🔊</span> Um pouco de ajuda',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Um pouco de ajuda&quot; )">🔊</span> 💡 Um pouco de ajuda:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Perguntas&quot; )">🔊</span> ❓ 1. PERGUNTAS',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;Esquema&quot; )">🔊</span> 💡 2. ESQUEMA',
      wizardStep2Title: '✏️ Passo 2: Sublinhado',
      wizardStep2Instruction: 'Identifica e marca os elementos do problema',
      highlightQuestion: 'Pergunta',
      highlightUseful: 'Dados Úteis',
      highlightClear: '🗑️ Apagar',
      validateHighlight: 'Validar Sublinhado',
      wizardStep3Title: '📊 Passo 3: Representação',
      wizardStep3Instruction: 'Representa as quantidades com barras',
      barLabel: 'Barra {n}: Ajusta para mostrar {value} {element}',
      barInstruction: 'Desloca o círculo vermelho até alcançar o valor {value}, já que são {value} {element}',
      validateRepresentation: 'Validar Representação',
      wizardStep4Title: '🤔 Passo 4: Raciocínio',
      wizardStep4Intro: 'Agora, observa a maior destas quantidades ({data}) e completa:',
      quantitiesReminder: '📊 Lembrete das quantidades:',
      largestDataLabel: 'O maior número relacionado com a pergunta é:',
      chooseLargest: '-- Escolhe o número maior --',
      rememberQuestion: 'Lembra-te da pergunta:',
      thinkAndAnswer: 'Agora pensa e responde, no final, o número de',
      willBeGreaterOrLess: 'será maior ou menor que',
      thanWord: 'que',
      chooseOption: '-- Escolhe --',
      optionGreater: 'MAIOR',
      optionLess: 'MENOR',
      validate: 'Validar',
      operationQuestion: 'Por fim, decide que operação deves fazer para responder: Adição ou Subtração?',
      optionSum: 'ADIÇÃO',
      optionSubtraction: 'SUBTRAÇÃO',
      validateContinue: 'Validar e Continuar',
      helpButton: 'AJUDA',
      helpText: 'Lembra-te que se o resultado esperado é maior que {value}, deves fazer uma ADIÇÃO, mas se o resultado esperado é menor que {value}, deves fazer uma SUBTRAÇÃO.',
      wizardStep5Title: '🧮 Passo 5: Cálculo',
      wizardStep5Instruction: 'ESCOLHE UM DOS 3 MÉTODOS PARA CALCULAR A SOLUÇÃO',
      method1Title: 'REALIZA ESTA OPERAÇÃO MATEMÁTICA COMPLETANDO A TABELA',
      method2Title: 'RESOLVE COM A GRELHA NUMÉRICA',
      method3Title: 'CALCULA MENTALMENTE E SELECIONA',
      checkButton: 'VERIFICAR',
      selectNumberBtn: 'Selecionar número',
      solveWithTable: 'Resolver com a grelha numérica',
      successCorrect: 'CORRETO!',
      successFound: 'Encontraste a resposta',
      wizardStep6Title: '✍️ Passo 6: Resposta Final',
      wizardStep6Instruction: 'Escreve a resposta completa',
      rememberOperation: 'Lembra-te que',
      addedVerb: 'adicionaste',
      subtractedVerb: 'subtraíste',
      thereforeAnswer: ', portanto, a resposta é:',
      submitAnswer: 'Enviar Resposta',
      summaryLabel: '📝 Resumo',
      summaryOperation: 'Operação:',
      summaryResult: 'Resultado:',
      goToCalcBtn: '🔢 Cálculo',
      feedbackPerfect: 'Perfeito!',
      feedbackVeryGood: 'Muito bem!',
      feedbackGreat: 'Ótimo!',
      feedbackCorrect: 'Correto!',
      feedbackFantastic: 'Fantástico!',
      feedbackTableCorrect: 'A tabela está correta!',
      feedbackOperationCorrect: 'Operação correta! Agora escreve a resposta final.',
      feedbackTryHighlight: 'Tenta marcar a pergunta e pelo menos um dado útil.',
      feedbackHighlightQuestionMissing: 'Lembra que a pergunta está entre as interrogações (¿...?).',
      feedbackHighlightDataWrong: 'Revê os dados úteis. São os números ou quantidades de {element} relacionados com a pergunta, com os quais deverás operar.',
      feedbackHighlightBothWrong: 'Lembra: a pergunta está entre as interrogações (¿...?) e os dados úteis são os números relacionados com a pergunta.',
      feedbackSelectNumber: 'Por favor, seleciona um dos números.',
      feedbackSelectMagnitude: 'Por favor, seleciona se será MAIOR ou MENOR.',
      feedbackSelectOperation: 'Por favor, seleciona a operação (ADIÇÃO ou SUBTRAÇÃO).',
      feedbackCompleteCalc: 'Completa o cálculo usando a tabela, o seletor numérico ou a ajuda',
      feedbackCheckCalc: 'Verifica o teu cálculo.',
      feedbackSelectResult: 'Por favor, seleciona um número para o resultado.',
      feedbackValuesAre: 'Os valores do problema são {values}. Ajusta as barras corretamente.',
      feedbackNumberCorrectButName: 'O número {number} está correto, mas verifica o nome do objeto. Deve ser "{name}".',
      feedbackNameCorrectButNumber: 'O nome "{name}" está correto, mas o número deveria ser {number}.',
      feedbackCorrectAnswer: 'A resposta correta era {answer} {element}. Continua a tentar!',
      hintLargestNumber: 'Dica: Qual é o número maior? Compara: {values}.',
      hintSumResult: 'Dica: Se somarmos duas quantidades, o resultado será maior ou menor que cada uma?',
      hintSubResult: 'Dica: Se subtrairmos uma quantidade de outra, o resultado será maior ou menor que o original?',
      hintExpectGreater: 'Dica: Se esperamos um resultado maior, que operação usamos para combinar?',
      hintExpectLess: 'Dica: Se esperamos um resultado menor, que operação usamos para tirar?',
      lastSelected: 'Último número selecionado:',
      sendAnswer: 'ENVIAR RESPOSTA',
      resetTable: '🔄 RECOMEÇAR',
      yourAnswer: 'A tua resposta:',
      send: 'ENVIAR',
      wrongAnswer: 'Resposta errada. Pensa mais ou usa outro método.',
      wrongAnswerLong: 'O número que selecionaste não é a resposta correta.',
      useHelpHint: '💡 Usa o botão "MOSTRAR AJUDA" para te guiarmos passo a passo.',
      step: 'PASSO',
      findNumber: 'Encontra e clica no número',
      understood: 'ENTENDIDO',
      tableScreenBack: 'Voltar',
      showHelp: 'MOSTRAR AJUDA',
      hideHelp: 'ESCONDER AJUDA',
      stepBack: 'ANTERIOR',
      stepNext: 'SEGUINTE',
      lastClicked: 'Último número selecionado',
      configuration: 'Configuração',
      problemCounter: 'Problema {current} de {total}',
      sessionComplete: 'Sessão Completa!',
      yourScore: 'A tua Pontuação',
      excellentWork: 'Excelente trabalho, Detetive Matemático!',
      missionComplete: 'Missão cumprida! Ganhaste pontos de experiência e medalhas pelo teu grande trabalho de detetive ao resolver este caso.',
      newSession: 'Nova Sessão',
      backToHome: 'Voltar ao Início',
      loading: 'A carregar aventura...',
      readProblem: 'Lê o Problema',
      problemTextAudio: 'TEXTO/ÁUDIO do problema',
      startAdventure: 'COMEÇAR A AVENTURA',
      previousStep: 'Passo Anterior',
      nextProblem: 'Próximo Problema',
      finishSession: 'Terminar Sessão',
      units: 'unidades',
      tableUnits: 'U',
      tableTens: 'D'
    }
  },
  'zh-CN': {
    code: 'zh-CN',
    name: '中文',
    nativeName: '中文',
    voice: { lang: 'zh-CN', pitch: 1.2, rate: 0.8 },
    strings: {
      title: '一年级数学侦探',
      welcome: '你好！准备好运用你的知识了吗？',
      selectLanguage: '语言',
      start: '开始',
      exit: '退出',
      contexts: '选择你的数学冒险',
      exitConfirm: '你确定要退出吗？',
      configTitle: '配置会话',
      back: '返回',
      previous: '上一个',
      continue: '继续',
      problemTypeTitle: '你想练习什么？',
      problemTypeAny: '加法或减法',
      problemTypeAnyDesc: '加法或减法问题混合',
      problemTypeSum: '加法',
      problemTypeSumDesc: '加法问题',
      problemTypeSubtraction: '减法',
      problemTypeSubtractionDesc: '减法问题',
      levelTitle: '你是什么等级？',
      levelBeginner: '初学者',
      levelBeginnerDesc: '1到10',
      levelAdvanced: '高级',
      levelAdvancedDesc: '1到20',
      levelExpert: '专家',
      levelExpertDesc: '1到50',
      contextTitle: '冒险在哪里进行？',
      contextFilterAll: '全部',
      contextFilterSpecial: '特别时刻',
      contextFilterShop: '购物',
      contextFilterNature: '自然',
      contextFilterDaily: '日常',
      contextFilterPlaces: '地点',

      tableSelectTitle: '选择数字',
      close: '关闭',
      abnTitle: '数字网格助手',
      abnCalculating: '计算中:',
      abnSteps: '步骤:',
      abnPrev: '上一个',
      abnNext: '下一个',
      abnUse: '使用结果',

      stepNavStep1: '完成每个步骤后，将进入下一个步骤，但如果愿意，可以前进到后续步骤',
      stepNavMiddle: '您可以前进或后退到所需的任何步骤',
      stepNavLast: '您可以返回到所需的任何步骤',

      wizardStep1Label: '理解',
      wizardStep2Label: '标记',
      wizardStep3Label: '表示',
      wizardStep4Label: '推理',
      wizardStep5Label: '计算',
      wizardStep6Label: '答案',
      wizardStep1Title: '📖 第1步：理解',
      wizardStep1Instruction: '仔细阅读问题。你理解了吗？',
      wizardStep1Question: '你理解问题了吗？',
      wizardStep1Yes: '✓ 是的，我理解',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;一点帮助&quot; )">🔊</span> 一点帮助',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;一点帮助&quot; )">🔊</span> 💡 一点帮助:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;问题&quot; )">🔊</span> ❓ 1. 问题',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;图解&quot; )">🔊</span> 💡 2. 图解',
      wizardStep2Title: '✏️ 第2步：标记',
      wizardStep2Instruction: '识别并标记问题的元素',
      highlightQuestion: '问题',
      highlightUseful: '有用数据',
      highlightClear: '🗑️ 清除',
      validateHighlight: '验证标记',
      wizardStep3Title: '📊 第3步：表示',
      wizardStep3Instruction: '用条形图表示数量',
      barLabel: '条 {n}：调整显示 {value} {element}',
      barInstruction: '移动红色圆圈直到达到值{value}，因为有{value}{element}',
      validateRepresentation: '验证表示',
      wizardStep4Title: '🤔 第4步：推理',
      wizardStep4Intro: '现在，看看这些数量中最大的（{data}）并完成：',
      quantitiesReminder: '📊 数量提醒：',
      largestDataLabel: '与问题相关的最大数字是：',
      chooseLargest: '-- 选择最大的数字 --',
      rememberQuestion: '记住问题：',
      thinkAndAnswer: '现在思考并回答，最终',
      willBeGreaterOrLess: '的数量会比',
      thanWord: '更',
      chooseOption: '-- 选择 --',
      optionGreater: '更多',
      optionLess: '更少',
      validate: '验证',
      operationQuestion: '最后，决定你需要做什么运算来回答：加法还是减法？',
      optionSum: '加法',
      optionSubtraction: '减法',
      validateContinue: '验证并继续',
      helpButton: '帮助',
      helpText: '记住，如果预期结果大于{value}，你应该做加法，但如果预期结果小于{value}，你应该做减法。',
      wizardStep5Title: '🧮 第5步：计算',
      wizardStep5Instruction: '选择3种方法之一来计算答案',
      method1Title: '通过填写表格完成这个数学运算',
      method2Title: '用数字网格解决',
      method3Title: '心算并选择',
      checkButton: '检查',
      selectNumberBtn: '选择数字',
      solveWithTable: '用数字网格解决',
      successCorrect: '正确！',
      successFound: '你找到了答案',
      wizardStep6Title: '✍️ 第6步：最终答案',
      wizardStep6Instruction: '写出完整的答案',
      rememberOperation: '记住你',
      addedVerb: '加了',
      subtractedVerb: '减了',
      thereforeAnswer: '，所以答案是：',
      submitAnswer: '提交答案',
      summaryLabel: '📝 摘要',
      summaryOperation: '运算：',
      summaryResult: '结果：',
      goToCalcBtn: '🔢 计算',
      feedbackPerfect: '完美！',
      feedbackVeryGood: '很好！',
      feedbackGreat: '太棒了！',
      feedbackCorrect: '正确！',
      feedbackFantastic: '太棒了！',
      feedbackTableCorrect: '表格正确！',
      feedbackOperationCorrect: '运算正确！现在写最终答案。',
      feedbackTryHighlight: '尝试标记问题和至少一个有用的数据。',
      feedbackHighlightQuestionMissing: '请记住,问题在问号之间(¿...?)。',
      feedbackHighlightDataWrong: '检查有用的数据。它们是与问题相关的{element}的数字或数量,你需要用它们进行运算。',
      feedbackHighlightBothWrong: '请记住:问题在问号之间(¿...?),有用的数据是与问题相关的数字。',
      feedbackSelectNumber: '请选择一个数字。',
      feedbackSelectMagnitude: '请选择结果会更多还是更少。',
      feedbackSelectOperation: '请选择运算（加法或减法）。',
      feedbackCompleteCalc: '使用表格、数字选择器或帮助完成计算',
      feedbackCheckCalc: '检查你的计算。',
      feedbackSelectResult: '请选择一个结果数字。',
      feedbackValuesAre: '问题的数值是{values}。正确调整条形图。',
      feedbackNumberCorrectButName: '数字{number}正确，但检查对象名称。应该是"{name}"。',
      feedbackNameCorrectButNumber: '名称"{name}"正确，但数字应该是{number}。',
      feedbackCorrectAnswer: '正确答案是{answer}{element}。继续努力！',
      hintLargestNumber: '提示：哪个数字最大？比较：{values}。',
      hintSumResult: '提示：如果我们把两个数量加起来，结果会比每个都大还是小？',
      hintSubResult: '提示：如果我们从一个数量减去另一个，结果会比原来大还是小？',
      hintExpectGreater: '提示：如果我们期望更大的结果，我们用什么运算来组合？',
      hintExpectLess: '提示：如果我们期望更小的结果，我们用什么运算来移除？',
      lastSelected: '最后选择的数字：',
      sendAnswer: '发送答案',
      resetTable: '🔄 重新开始',
      yourAnswer: '你的答案：',
      send: '发送',
      wrongAnswer: '答案错误。再想想或用其他方法。',
      wrongAnswerLong: '你选择的数字不是正确答案。',
      useHelpHint: '💡 使用"显示帮助"按钮，我们会一步步引导你。',
      step: '第',
      findNumber: '找到并点击数字',
      understood: '明白了',
      tableScreenBack: '返回',
      showHelp: '显示帮助',
      hideHelp: '隐藏帮助',
      stepBack: '后退',
      stepNext: '下一个',
      lastClicked: '最后选择的数字',
      configuration: '配置',
      problemCounter: '问题 {current} / {total}',
      sessionComplete: '会话完成！',
      yourScore: '你的分数',
      excellentWork: '做得好，数学侦探！',
      missionComplete: '任务完成！你在解决这个案件中出色的侦探工作为你赢得了经验值和奖牌。',
      newSession: '新会话',
      backToHome: '返回首页',
      loading: '加载冒险中...',
      readProblem: '阅读问题',
      problemTextAudio: '问题文本/音频',
      startAdventure: '开始冒险',
      previousStep: '上一步',
      nextProblem: '下一个问题',
      finishSession: '结束会话',
      units: '个',
      tableUnits: '个',
      tableTens: '十'
    }
  },
  'hi-IN': {
    code: 'hi-IN',
    name: 'हिन्दी',
    nativeName: 'हिन्दी',
    voice: { lang: 'hi-IN', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'पहली कक्षा के गणित जासूस',
      welcome: 'नमस्ते! अपने ज्ञान को व्यवहार में लाने के लिए तैयार हैं?',
      selectLanguage: 'भाषा',
      start: 'शुरू करें',
      exit: 'बाहर निकलें',
      contexts: 'अपने गणित साहसिक कार्य का चयन करें',
      exitConfirm: 'क्या आप वाकई बाहर निकलना चाहते हैं?',
      configTitle: 'अपना सत्र कॉन्फ़िगर करें',
      back: 'पीछे',
      previous: 'पिछला',
      continue: 'जारी रखें',
      problemTypeTitle: 'आप क्या अभ्यास करना चाहते हैं?',
      problemTypeAny: 'जोड़ या घटाना',
      problemTypeAnyDesc: 'जोड़ या घटाना समस्याओं का मिश्रण',
      problemTypeSum: 'जोड़',
      problemTypeSumDesc: 'जोड़ समस्याएं',
      problemTypeSubtraction: 'घटाना',
      problemTypeSubtractionDesc: 'घटाना समस्याएं',
      levelTitle: 'आपका स्तर क्या है?',
      levelBeginner: 'शुरुआती',
      levelBeginnerDesc: '1 से 10',
      levelAdvanced: 'उन्नत',
      levelAdvancedDesc: '1 से 20',
      levelExpert: 'विशेषज्ञ',
      levelExpertDesc: '1 से 50',
      contextTitle: 'साहसिक कार्य कहां होता है?',
      contextFilterAll: 'सभी',
      contextFilterSpecial: 'विशेष क्षण',
      contextFilterShop: 'खरीदारी',
      contextFilterNature: 'प्रकृति',
      contextFilterDaily: 'दैनिक',
      contextFilterPlaces: 'स्थान',

      tableSelectTitle: 'संख्या चुनें',
      close: 'बंद करें',
      abnTitle: 'संख्या ग्रिड सहायता',
      abnCalculating: 'गणना:',
      abnSteps: 'चरण:',
      abnPrev: 'पिछला',
      abnNext: 'अगला',
      abnUse: 'परिणाम का उपयोग करें',

      stepNavStep1: 'प्रत्येक चरण पूरा करने पर, आप अगले चरण पर जाएंगे, लेकिन यदि चाहें, तो आप बाद के चरण पर आगे बढ़ सकते हैं',
      stepNavMiddle: 'आप अपनी इच्छानुसार किसी भी चरण पर आगे या पीछे जा सकते हैं',
      stepNavLast: 'आप अपनी इच्छानुसार किसी भी पिछले चरण पर वापस जा सकते हैं',

      wizardStep1Label: 'समझ',
      wizardStep2Label: 'हाइलाइट',
      wizardStep3Label: 'प्रतिनिधित्व',
      wizardStep4Label: 'तर्क',
      wizardStep5Label: 'गणना',
      wizardStep6Label: 'उत्तर',
      wizardStep1Title: '📖 चरण 1: समझ',
      wizardStep1Instruction: 'समस्या को ध्यान से पढ़ें। क्या आप समझते हैं?',
      wizardStep1Question: 'क्या आपने समस्या समझ ली?',
      wizardStep1Yes: '✓ हां, मैं समझता हूं',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;थोड़ी मदद&quot; )">🔊</span> थोड़ी मदद',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;थोड़ी मदद&quot; )">🔊</span> 💡 थोड़ी मदद:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;प्रश्न&quot; )">🔊</span> ❓ 1. प्रश्न',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;आरेख&quot; )">🔊</span> 💡 2. आरेख',
      wizardStep2Title: '✏️ चरण 2: हाइलाइट करना',
      wizardStep2Instruction: 'समस्या के तत्वों को पहचानें और चिह्नित करें',
      highlightQuestion: 'प्रश्न',
      highlightUseful: 'उपयोगी डेटा',
      highlightClear: '🗑️ मिटाएं',
      validateHighlight: 'हाइलाइट सत्यापित करें',
      wizardStep3Title: '📊 चरण 3: प्रतिनिधित्व',
      wizardStep3Instruction: 'बार से मात्राओं को दर्शाएं',
      barLabel: 'बार {n}: {value} {element} दिखाने के लिए समायोजित करें',
      barInstruction: 'लाल वृत्त को मान {value} तक पहुंचने के लिए घुमाएं, क्योंकि वे {value} {element} हैं',
      validateRepresentation: 'प्रतिनिधित्व सत्यापित करें',
      wizardStep4Title: '🤔 चरण 4: तर्क',
      wizardStep4Intro: 'अब, इन मात्राओं में सबसे बड़ी ({data}) को देखें और पूरा करें:',
      quantitiesReminder: '📊 मात्राओं का अनुस्मारक:',
      largestDataLabel: 'प्रश्न से संबंधित सबसे बड़ी संख्या है:',
      chooseLargest: '-- सबसे बड़ी संख्या चुनें --',
      rememberQuestion: 'प्रश्न याद रखें:',
      thinkAndAnswer: 'अब सोचें और जवाब दें, अंत में',
      willBeGreaterOrLess: 'की संख्या से अधिक या कम होगी',
      thanWord: 'से',
      chooseOption: '-- चुनें --',
      optionGreater: 'अधिक',
      optionLess: 'कम',
      validate: 'सत्यापित करें',
      operationQuestion: 'अंत में, तय करें कि उत्तर देने के लिए कौन सी गणना करनी होगी: जोड़ या घटाव?',
      optionSum: 'जोड़',
      optionSubtraction: 'घटाव',
      validateContinue: 'सत्यापित करें और जारी रखें',
      helpButton: 'मदद',
      helpText: 'याद रखें कि यदि अपेक्षित परिणाम {value} से अधिक है, तो आपको जोड़ करना चाहिए, लेकिन यदि अपेक्षित परिणाम {value} से कम है, तो आपको घटाव करना चाहिए।',
      wizardStep5Title: '🧮 चरण 5: गणना',
      wizardStep5Instruction: 'समाधान की गणना के लिए 3 तरीकों में से एक चुनें',
      method1Title: 'तालिका भरकर इस गणित की गणना करें',
      method2Title: 'संख्या ग्रिड से हल करें',
      method3Title: 'मानसिक गणना करें और चुनें',
      checkButton: 'जांचें',
      selectNumberBtn: 'संख्या चुनें',
      solveWithTable: 'संख्या ग्रिड से हल करें',
      successCorrect: 'सही!',
      successFound: 'आपने उत्तर पाया',
      wizardStep6Title: '✍️ चरण 6: अंतिम उत्तर',
      wizardStep6Instruction: 'पूर्ण उत्तर लिखें',
      rememberOperation: 'याद रखें कि आपने',
      addedVerb: 'जोड़ा',
      subtractedVerb: 'घटाया',
      thereforeAnswer: ', इसलिए उत्तर है:',
      submitAnswer: 'उत्तर भेजें',
      summaryLabel: '📝 सारांश',
      summaryOperation: 'गणना:',
      summaryResult: 'परिणाम:',
      goToCalcBtn: '🔢 गणना',
      feedbackPerfect: 'उत्तम!',
      feedbackVeryGood: 'बहुत अच्छा!',
      feedbackGreat: 'शानदार!',
      feedbackCorrect: 'सही!',
      feedbackFantastic: 'अद्भुत!',
      feedbackTableCorrect: 'तालिका सही है!',
      feedbackOperationCorrect: 'गणना सही! अब अंतिम उत्तर लिखें।',
      feedbackTryHighlight: 'प्रश्न और कम से कम एक उपयोगी डेटा को चिह्नित करने का प्रयास करें।',
      feedbackHighlightQuestionMissing: 'याद रखें कि प्रश्न प्रश्न चिह्नों के बीच है (¿...?)।',
      feedbackHighlightDataWrong: 'उपयोगी डेटा की समीक्षा करें। वे {element} की संख्या या मात्रा हैं जो प्रश्न से संबंधित हैं, जिनके साथ आपको संचालन करना होगा।',
      feedbackHighlightBothWrong: 'याद रखें: प्रश्न प्रश्न चिह्नों के बीच है (¿...?) और उपयोगी डेटा वे संख्याएं हैं जो प्रश्न से संबंधित हैं।',
      feedbackSelectNumber: 'कृपया संख्याओं में से एक चुनें।',
      feedbackSelectMagnitude: 'कृपया चुनें कि यह अधिक होगा या कम।',
      feedbackSelectOperation: 'कृपया गणना चुनें (जोड़ या घटाव)।',
      feedbackCompleteCalc: 'तालिका, संख्या चयनकर्ता या सहायता का उपयोग करके गणना पूर्ण करें',
      feedbackCheckCalc: 'अपनी गणना जांचें।',
      feedbackSelectResult: 'कृपया परिणाम के लिए एक संख्या चुनें।',
      feedbackValuesAre: 'समस्या के मान {values} हैं। बार सही ढंग से समायोजित करें।',
      feedbackNumberCorrectButName: 'संख्या {number} सही है, लेकिन वस्तु का नाम जांचें। यह "{name}" होना चाहिए।',
      feedbackNameCorrectButNumber: 'नाम "{name}" सही है, लेकिन संख्या {number} होनी चाहिए।',
      feedbackCorrectAnswer: 'सही उत्तर {answer} {element} था। प्रयास जारी रखें!',
      hintLargestNumber: 'संकेत: कौन सी संख्या सबसे बड़ी है? तुलना करें: {values}।',
      hintSumResult: 'संकेत: यदि हम दो मात्राएं जोड़ते हैं, तो परिणाम प्रत्येक से अधिक होगा या कम?',
      hintSubResult: 'संकेत: यदि हम एक मात्रा को दूसरी से घटाते हैं, तो परिणाम मूल से अधिक होगा या कम?',
      hintExpectGreater: 'संकेत: यदि हम बड़े परिणाम की उम्मीद करते हैं, तो हम किस गणना का उपयोग करते हैं?',
      hintExpectLess: 'संकेत: यदि हम छोटे परिणाम की उम्मीद करते हैं, तो हम किस गणना का उपयोग करते हैं?',
      lastSelected: 'अंतिम चयनित संख्या:',
      sendAnswer: 'उत्तर भेजें',
      resetTable: '🔄 फिर से शुरू करें',
      yourAnswer: 'आपका उत्तर:',
      send: 'भेजें',
      wrongAnswer: 'गलत उत्तर। और सोचें या अन्य तरीका उपयोग करें।',
      wrongAnswerLong: 'आपने जो संख्या चुनी वह सही उत्तर नहीं है।',
      useHelpHint: '💡 "सहायता दिखाएं" बटन का उपयोग करें, हम आपको चरण-दर-चरण मार्गदर्शन करेंगे।',
      step: 'चरण',
      findNumber: 'संख्या खोजें और क्लिक करें',
      understood: 'समझ गया',
      tableScreenBack: 'वापस',
      showHelp: 'सहायता दिखाएं',
      hideHelp: 'सहायता छिपाएं',
      stepBack: 'पीछे',
      stepNext: 'अगला',
      lastClicked: 'अंतिम चयनित संख्या',
      configuration: 'कॉन्फ़िगरेशन',
      problemCounter: 'समस्या {current} / {total}',
      sessionComplete: 'सत्र पूर्ण!',
      yourScore: 'आपका स्कोर',
      excellentWork: 'उत्कृष्ट कार्य, गणित जासूस!',
      missionComplete: 'मिशन पूरा हुआ! आपने इस मामले को सुलझाने में अपने बेहतरीन जासूसी कार्य के लिए अनुभव अंक और पदक अर्जित किए हैं।',
      newSession: 'नया सत्र',
      backToHome: 'होम पर वापस',
      loading: 'साहसिक कार्य लोड हो रहा है...',
      readProblem: 'समस्या पढ़ें',
      problemTextAudio: 'समस्या पाठ/ऑडियो',
      startAdventure: 'साहसिक कार्य शुरू करें',
      previousStep: 'पिछला चरण',
      nextProblem: 'अगली समस्या',
      finishSession: 'सत्र समाप्त करें',
      units: 'इकाइयां',
      tableUnits: 'इ',
      tableTens: 'द'
    }
  },
  'ar-XA': {
    code: 'ar-XA',
    name: 'العربية',
    nativeName: 'العربية',
    voice: { lang: 'ar-SA', pitch: 1.2, rate: 0.8 },
    strings: {
      title: 'محققو الرياضيات للصف الأول',
      welcome: 'مرحبا! هل أنت مستعد لتطبيق معرفتك؟',
      selectLanguage: 'اللغة',
      start: 'ابدأ',
      exit: 'خروج',
      contexts: 'اختر مغامرتك الرياضية',
      exitConfirm: 'هل أنت متأكد أنك تريد الخروج؟',
      configTitle: 'اضبط جلستك',
      back: 'عودة',
      previous: 'السابق',
      continue: 'التالي',
      problemTypeTitle: 'ماذا تريد أن تمارس؟',
      problemTypeAny: 'جمع أو طرح',
      problemTypeAnyDesc: 'مزيج من مسائل الجمع أو الطرح',
      problemTypeSum: 'جمع',
      problemTypeSumDesc: 'مسائل الجمع',
      problemTypeSubtraction: 'طرح',
      problemTypeSubtractionDesc: 'مسائل الطرح',
      levelTitle: 'ما هو مستواك؟',
      levelBeginner: 'مبتدئ',
      levelBeginnerDesc: 'من 1 إلى 10',
      levelAdvanced: 'متقدم',
      levelAdvancedDesc: 'من 1 إلى 20',
      levelExpert: 'خبير',
      levelExpertDesc: 'من 1 إلى 50',
      contextTitle: 'أين تحدث المغامرة؟',
      contextFilterAll: 'الكل',
      contextFilterSpecial: 'لحظات خاصة',
      contextFilterShop: 'تسوق',
      contextFilterNature: 'طبيعة',
      contextFilterDaily: 'يومي',
      contextFilterPlaces: 'أماكن',

      tableSelectTitle: 'اختر الرقم',
      close: 'إغلاق',
      abnTitle: 'مساعد الشبكة الرقمية',
      abnCalculating: 'جاري الحساب:',
      abnSteps: 'الخطوات:',
      abnPrev: 'السابق',
      abnNext: 'التالي',
      abnUse: 'استخدام النتيجة',

      stepNavStep1: 'عند إكمال كل خطوة، ستنتقل إلى الخطوة التالية، ولكن إذا رغبت، يمكنك التقدم إلى خطوة لاحقة',
      stepNavMiddle: 'يمكنك التقدم أو الرجوع إلى أي خطوة ترغب فيها',
      stepNavLast: 'يمكنك الرجوع إلى أي خطوة سابقة ترغب فيها',

      // Wizard Step Labels
      wizardStep1Label: 'الفهم',
      wizardStep2Label: 'التحديد',
      wizardStep3Label: 'التمثيل',
      wizardStep4Label: 'الاستدلال',
      wizardStep5Label: 'الحساب',
      wizardStep6Label: 'الإجابة',
      wizardStep1Title: '📖 الخطوة 1: الفهم',
      wizardStep1Instruction: 'اقرأ المسألة بعناية. هل فهمتها؟',
      wizardStep1Question: 'هل فهمت المسألة؟',
      wizardStep1Yes: '✓ نعم، فهمت',
      wizardStep1Help: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;القليل من المساعدة&quot; )">🔊</span> القليل من المساعدة',
      wizardStep1HelpHeader: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;القليل من المساعدة&quot; )">🔊</span> 💡 القليل من المساعدة:',
      wizardStep1HelpQuestions: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;أسئلة&quot; )">🔊</span> ❓ 1. أسئلة',
      wizardStep1HelpSchema: '<span class="btn-audio-inline auto-enforced" style="margin-right:8px" onclick="window.toggleAudio(this, &quot;مخطط&quot; )">🔊</span> 💡 2. مخطط',
      wizardStep2Title: '✏️ الخطوة 2: التحديد',
      wizardStep2Instruction: 'حدد وميز عناصر المسألة',
      highlightQuestion: 'السؤال',
      highlightUseful: 'البيانات المفيدة',
      highlightClear: '🗑️ مسح',
      validateHighlight: 'تحقق من التحديد',
      wizardStep3Title: '📊 الخطوة 3: التمثيل',
      wizardStep3Instruction: 'مثّل الكميات بالأعمدة',
      barLabel: 'العمود {n}: اضبط لإظهار {value} {element}',
      barInstruction: 'حرك الدائرة الحمراء حتى تصل إلى القيمة {value}، لأنها {value} {element}',
      validateRepresentation: 'تحقق من التمثيل',
      wizardStep4Title: '🤔 الخطوة 4: الاستدلال',
      wizardStep4Intro: 'الآن، انظر إلى أكبر هذه الكميات ({data}) وأكمل:',
      quantitiesReminder: '📊 تذكير بالكميات:',
      largestDataLabel: 'أكبر رقم متعلق بالسؤال هو:',
      chooseLargest: '-- اختر الرقم الأكبر --',
      rememberQuestion: 'تذكر السؤال:',
      thinkAndAnswer: 'الآن فكر وأجب، هل العدد النهائي من',
      willBeGreaterOrLess: 'سيكون أكبر أم أصغر من',
      thanWord: 'من',
      chooseOption: '-- اختر --',
      optionGreater: 'أكبر',
      optionLess: 'أصغر',
      validate: 'تحقق',
      operationQuestion: 'أخيرًا، قرر أي عملية تحتاج لأدائها للإجابة على السؤال: جمع أم طرح؟',
      optionSum: 'جمع',
      optionSubtraction: 'طرح',
      validateContinue: 'تحقق واستمر',
      helpButton: 'مساعدة',
      helpText: 'تذكر أنه إذا كانت النتيجة المتوقعة أكبر من {value}، يجب إجراء عملية جمع، ولكن إذا كانت النتيجة المتوقعة أصغر من {value}، يجب إجراء عملية طرح.',
      wizardStep5Title: '🧮 الخطوة 5: الحساب',
      wizardStep5Instruction: 'اختر واحدة من الطرق الثلاث لحساب الحل',
      method1Title: 'أكمل هذه العملية الرياضية بملء الجدول',
      method2Title: 'حل باستخدام شبكة الأرقام',
      method3Title: 'احسب ذهنيًا واختر',
      checkButton: 'تحقق',
      selectNumberBtn: 'اختر رقمًا',
      solveWithTable: 'حل باستخدام شبكة الأرقام',
      successCorrect: 'صحيح!',
      successFound: 'لقد وجدت الإجابة',
      wizardStep6Title: '✍️ الخطوة 6: الإجابة النهائية',
      wizardStep6Instruction: 'اكتب الإجابة الكاملة',
      rememberOperation: 'تذكر أنك',
      addedVerb: 'جمعت',
      subtractedVerb: 'طرحت',
      thereforeAnswer: '، لذلك الإجابة هي:',
      submitAnswer: 'إرسال الإجابة',
      summaryLabel: '📝 ملخص',
      summaryOperation: 'العملية:',
      summaryResult: 'النتيجة:',
      goToCalcBtn: '🔢 الحساب',

      // Feedback Messages
      feedbackPerfect: 'ممتاز!',
      feedbackVeryGood: 'جيد جدًا!',
      feedbackGreat: 'رائع!',
      feedbackCorrect: 'صحيح!',
      feedbackFantastic: 'مذهل!',
      feedbackTableCorrect: 'الجدول صحيح!',
      feedbackOperationCorrect: 'العملية صحيحة! الآن اكتب الإجابة النهائية.',
      feedbackTryHighlight: 'حاول تحديد السؤال وبيانات مفيدة واحدة على الأقل.',
      feedbackHighlightQuestionMissing: 'تذكر أن السؤال بين علامات الاستفهام (¿...?).',
      feedbackHighlightDataWrong: 'راجع البيانات المفيدة. هي الأرقام أو كميات {element} المرتبطة بالسؤال، والتي ستحتاج إلى استخدامها في العملية.',
      feedbackHighlightBothWrong: 'تذكر: السؤال بين علامات الاستفهام (¿...?) والبيانات المفيدة هي الأرقام المرتبطة بالسؤال.',
      feedbackSelectNumber: 'يرجى اختيار أحد الأرقام.',
      feedbackSelectMagnitude: 'يرجى اختيار ما إذا كانت ستكون أكبر أم أصغر.',
      feedbackSelectOperation: 'يرجى اختيار العملية (جمع أو طرح).',
      feedbackCompleteCalc: 'أكمل الحساب باستخدام الجدول أو محدد الأرقام أو مساعد الشبكة',
      feedbackCheckCalc: 'راجع حسابك.',
      feedbackSelectResult: 'يرجى اختيار رقم للنتيجة.',
      feedbackValuesAre: 'قيم المسألة هي {values}. اضبط الأعمدة بشكل صحيح.',
      feedbackNumberCorrectButName: 'الرقم {number} صحيح، لكن تحقق من اسم الكائن. يجب أن يكون "{name}".',
      feedbackNameCorrectButNumber: 'الاسم "{name}" صحيح، لكن الرقم يجب أن يكون {number}.',
      feedbackCorrectAnswer: 'الإجابة الصحيحة كانت {answer} {element}. استمر في المحاولة!',

      // Hints
      hintLargestNumber: 'تلميح: أي رقم هو الأكبر؟ قارن: {values}.',
      hintSumResult: 'تلميح: إذا جمعنا كميتين، هل ستكون النتيجة أكبر أم أصغر من كل منهما؟',
      hintSubResult: 'تلميح: إذا طرحنا كمية من أخرى، هل ستكون النتيجة أكبر أم أصغر من الأصلية؟',
      hintExpectGreater: 'تلميح: إذا توقعنا نتيجة أكبر، أي عملية نستخدم لدمج الكميات؟',
      hintExpectLess: 'تلميح: إذا توقعنا نتيجة أصغر، أي عملية نستخدم لإزالة كمية؟',

      // Numeric Table Screen
      lastSelected: 'آخر رقم تم اختياره:',
      sendAnswer: 'إرسال الإجابة',
      resetTable: '🔄 ابدأ من جديد',
      yourAnswer: 'إجابتك:',
      send: 'إرسال',
      wrongAnswer: 'إجابة خاطئة. فكر أكثر أو استخدم طريقة أخرى.',
      wrongAnswerLong: 'الرقم الذي اخترته ليس الإجابة الصحيحة.',
      useHelpHint: '💡 استخدم زر "إظهار المساعدة" لنرشدك خطوة بخطوة إلى الحل.',
      step: 'الخطوة',
      findNumber: 'ابحث وانقر على الرقم',
      understood: 'مفهوم',
      tableScreenBack: 'عودة',
      showHelp: 'إظهار المساعدة',
      hideHelp: 'إخفاء المساعدة',
      stepBack: 'رجوع',
      stepNext: 'التالي',
      lastClicked: 'آخر رقم تم اختياره',

      // Navigation
      configuration: 'الإعدادات',
      problemCounter: 'المسألة {current} من {total}',
      sessionComplete: 'اكتملت الجلسة!',
      yourScore: 'نتيجتك',
      excellentWork: 'عمل ممتاز، محقق الرياضيات!',
      missionComplete: 'اكتملت المهمة! لقد حصلت على نقاط خبرة وميداليات لعملك الاستقصائي الرائع في حل هذه القضية.',
      newSession: 'جلسة جديدة',
      backToHome: 'العودة للرئيسية',
      loading: 'جاري تحميل المغامرة...',
      readProblem: 'اقرأ المسألة',
      problemTextAudio: 'نص/صوت المسألة',
      startAdventure: 'ابدأ المغامرة',
      previousStep: 'الخطوة السابقة',
      nextProblem: 'المسألة التالية',
      finishSession: 'إنهاء الجلسة',
      units: 'وحدات',
      tableUnits: 'آ',
      tableTens: 'ع'
    }
  }
};

// Exportar para uso global y en app.js
window.LANGUAGES = LANGUAGES;
if (typeof module !== 'undefined' && module.exports) {
  module.exports = LANGUAGES;
}
